const sk = {
  'common.loading': 'Načítava sa…',
  'common.save': 'Uložiť',
  'common.cancel': 'Zrušiť',
  'common.delete': 'Odstrániť',
  'common.search': 'Hľadať',
  'common.accessDenied': 'Prístup zamietnutý',
  'common.backToLogin': 'Späť na prihlásenie',
  'common.markAsRead': 'Označiť ako prečítané',
  'shell.supportDesk': 'Centrum podpory',
  'shell.searchPlaceholder': 'Hľadať tikety, kontakty, články…',
  'shell.newTicket': 'Nový tiket',
  'shell.notifications': 'Oznámenia',
  'shell.notificationPreferences': 'Nastavenia oznámení',
  'shell.settings': 'Nastavenia',
  'shell.signOut': 'Odhlásiť sa',
  'shell.expandNavigation': 'Rozbaliť navigáciu',
  'shell.collapseNavigation': 'Zbaliť navigáciu',
  'shell.caughtUp': 'Všetko je vybavené',
  'shell.viewAllNotifications': 'Zobraziť všetky oznámenia',
  'nav.dashboard': 'Prehľad',
  'nav.tickets': 'Tikety',
  'nav.contacts': 'Kontakty',
  'nav.companies': 'Spoločnosti',
  'nav.reports': 'Prehľady',
  'nav.settings': 'Nastavenia',
  'nav.agents': 'Agenti',
  'nav.groups': 'Skupiny',
  'nav.roles': 'Úlohy',
  'nav.tags': 'Značky',
  'nav.ticketFields': 'Polia tiketu',
  'nav.ticketForms': 'Formuláre tiketov',
  'nav.businessHours': 'Pracovný čas',
  'nav.slaPolicies': 'Pravidlá SLA',
  'nav.automations': 'Automatizácie',
  'nav.email': 'E-mail',
  'nav.notificationTemplates': 'Šablóny oznámení',
  'nav.apiKeys': 'Kľúče API',
  'nav.cannedResponses': 'Uložené odpovede',
  'nav.knowledgeBase': 'Znalostná databáza',
  'auth.signInTitle': 'Centrum podpory SDPL',
  'auth.signInSubtitle': 'Prihláste sa do svojho účtu',
  'auth.emailAddress': 'E-mailová adresa',
  'auth.password': 'Heslo',
  'auth.signingIn': 'Prihlasovanie…',
  'auth.signIn': 'Prihlásiť sa',
  'auth.forgotPassword': 'Zabudli ste heslo?',
  'auth.twoFactor': 'Dvojfaktorové overenie',
  'auth.verificationCode': 'Overovací kód',
  'auth.verify': 'Overiť',
  'auth.backToLogin': 'Späť na prihlásenie',
  'agents.title': 'Agenti',
  'agents.new': 'Nový agent',
  'agents.supportAgents': 'Agenti podpory',
  'agents.collaborators': 'Spolupracovníci',
  'agents.deactivated': 'Deaktivovaní',
  'agents.searchPlaceholder': 'Hľadať podľa mena alebo e-mailu',
  'agents.edit': 'Upraviť',
  'agents.deactivate': 'Deaktivovať',
  'agents.reactivate': 'Znovu aktivovať',
  'agents.saved': 'Agent bol uložený.',
  'agents.firstName': 'Meno',
  'agents.lastName': 'Priezvisko',
  'agents.email': 'E-mail',
  'agents.phone': 'Telefón',
  'agents.timezone': 'Časové pásmo',
  'agents.selectTimezone': 'Vyberte časové pásmo',
  'agents.language': 'Jazyk',
  'agents.selectLanguage': 'Vyberte jazyk',
  'agents.emailSignature': 'E-mailový podpis',
  'agents.roleRequired': 'Úloha',
  'agents.selectRole': 'Vyberte úlohu',
  'agents.status': 'Stav',
  'agents.groupsTitle': 'Skupiny',
  'agents.manageGroups': 'Spravovať skupiny',
  'agents.notInGroup': 'Zatiaľ nie je v žiadnej skupine',
  'dashboard.title': 'Prehľad',
  'dashboard.description': 'Aktuálne pracovné zaťaženie podpory a stav služby.',
  'dashboard.allGroups': 'Všetky dostupné skupiny',
  'dashboard.unresolved': 'Nevyriešené',
  'dashboard.overdue': 'Po termíne',
  'dashboard.dueToday': 'Splatné dnes',
  'dashboard.open': 'Otvorené',
  'dashboard.onHold': 'Pozastavené',
  'dashboard.unassigned': 'Nepriradené',
  'dashboard.trends': 'Dnešné trendy',
  'notifications.title': 'Oznámenia',
  'notifications.description': 'Úplná história vašich oznámení.',
  'notifications.markAllRead': 'Označiť všetko ako prečítané',
  'notifications.filter': 'Filter',
  'notifications.allTypes': 'Všetky typy',
  'notifications.none': 'Zatiaľ žiadne oznámenia',
  'notifications.assigned': 'Priradené',
  'notifications.reply': 'Odpoveď',
  'notifications.note': 'Poznámka',
  'notifications.slaWarning': 'Upozornenie SLA',
  'notifications.slaBreach': 'Porušenie SLA',
  'notifications.slaEscalation': 'Eskalácia SLA',
  'notifications.mention': 'Zmienenie',
  'preferences.title': 'Nastavenia oznámení',
  'preferences.description': 'Oznámenia v aplikácii zostávajú zapnuté. Vyberte, ktoré majú posielať aj e-mail.',
  'preferences.emailDigest': 'E-mailový prehľad',
  'preferences.dailySummary': 'Jeden denný súhrnný e-mail namiesto e-mailu pre každú udalosť.',
  'preferences.digestOff': 'Vypnuté — e-mail pre každú udalosť',
  'preferences.digestDaily': 'Denný prehľad',
  'preferences.emailNotifications': 'E-mailové oznámenia',
  'activities.button': 'Nedávne aktivity',
  'activities.title': 'Nedávne aktivity',
  'activities.loadError': 'Nedávne aktivity sa nepodarilo načítať.',
  'activities.systemActor': 'Systém',
  'activities.noneTitle': 'Zatiaľ žiadna nedávna aktivita',
  'activities.noneDescription': 'Aktualizácie tiketov od vás a vašej skupiny sa tu zobrazia, ako sa vyskytnú.',
  'tickets.title': 'Tikety',
  'tickets.description': 'Všetky tikety, ku ktorým máte prístup, filtrované a zoradené podľa vašich potrieb.',
  'tickets.dueDateTabs': 'Termín tiketu',
  'tickets.tabAll': 'Všetky tikety',
  'tickets.tabDueToday': 'Termín dnes',
  'tickets.tabOverdue': 'Po termíne',
  'tickets.tabDueTomorrow': 'Termín zajtra',
  'tickets.searchPlaceholder': 'Hľadať tikety…',
  'tickets.searchAria': 'Hľadať tikety',
  'tickets.filters': 'Filtre',
  'tickets.filtersWithCount': 'Filtre ({count})',
  'tickets.sortAria': 'Zoradiť tikety podľa',
  'tickets.sortTrigger': 'Zoradiť: {label}',
  'tickets.sortDateCreated': 'Dátum vytvorenia',
  'tickets.sortDateUpdated': 'Dátum aktualizácie',
  'tickets.sortPriority': 'Priorita',
  'tickets.sortStatus': 'Stav',
  'tickets.sortDueDate': 'Termín',
  'tickets.sortAscending': 'Zoradiť vzostupne',
  'tickets.sortDescending': 'Zoradiť zostupne',
  'tickets.ascending': 'Vzostupne',
  'tickets.descending': 'Zostupne',
  'tickets.layoutAria': 'Rozloženie riadkov',
  'tickets.layoutTrigger': 'Rozloženie: {label}',
  'tickets.layoutCard': 'Karta',
  'tickets.layoutInbox': 'Doručená pošta',
  'tickets.layoutTable': 'Tabuľka',
  'tickets.export': 'Exportovať',
  'tickets.exportSelected': 'Exportovať vybrané',
  'tickets.selectedCount': 'Vybraté: {count}',
  'tickets.assignAgent': 'Priradiť agenta',
  'tickets.closeAll': 'Zavrieť všetky',
  'tickets.clearSelection': 'Zrušiť výber',
  'tickets.selectAgentPlaceholder': 'Vyberte agenta...',
  'tickets.assignTo': 'Priradiť k',
  'tickets.assign': 'Priradiť',
  'tickets.loadFailed': 'Tikety sa nepodarilo načítať. Skúste to znova.',
  'tickets.bulkCloseFailed': 'Vybrané tikety sa nepodarilo zavrieť. Skúste to znova.',
  'tickets.bulkAssignFailed': 'Vybrané tikety sa nepodarilo priradiť. Skúste to znova.',
  'tickets.noFilterMatchTitle': 'Týmto filtrom nezodpovedá žiadny tiket',
  'tickets.noFilterMatchDescription': 'Skúste odstrániť filter, rozšíriť časový rozsah alebo vyhľadať iný výraz.',
  'tickets.clearFilters': 'Vymazať filtre',
  'tickets.queueClearTitle': 'Tento front je prázdny',
  'tickets.queueClearDescription': 'Nové tikety sa tu zobrazia, keď klient napíše e-mail, použije portál alebo agent vytvorí tiket.',
  'tickets.newTicket': 'Nový tiket',
  'tickets.selectAllAria': 'Vybrať všetky tikety',
  'tickets.selectTicketAria': 'Vybrať tiket č. {number}',
  'tickets.columnContact': 'Kontakt',
  'tickets.columnSubject': 'Predmet',
  'tickets.columnState': 'Stav',
  'tickets.columnGroup': 'Skupina',
  'tickets.columnAgent': 'Agent',
  'tickets.columnPriority': 'Priorita',
  'tickets.noGroup': 'Žiadna skupina',
  'tickets.unassigned': 'Nepriradené',
  'tickets.createdRelative': 'Vytvorené {when}',
  'tickets.unassignedOnly': 'Iba nepriradené',
  'tickets.unknownRequester': 'Neznámy žiadateľ',
  'tickets.overdueBy': 'Po termíne o {duration}',
  'tickets.dueIn': 'Termín za {duration}',
  'tickets.filtersDrawerTitle': 'Filtre',
  'tickets.filtersSearchPlaceholder': 'Hľadať polia',
  'tickets.filtersSearchAria': 'Hľadať polia filtra',
  'tickets.filtersClearAll': 'Vymazať všetko',
  'tickets.filtersApply': 'Použiť',
  'tickets.filterAgents': 'Agenti',
  'tickets.filterAnyAgent': 'Ktorýkoľvek agent',
  'tickets.filterGroups': 'Skupiny',
  'tickets.filterAnyGroup': 'Ktorákoľvek skupina',
  'tickets.filterStatus': 'Stav',
  'tickets.filterAnyStatus': 'Ktorýkoľvek stav',
  'tickets.filterPriority': 'Priorita',
  'tickets.filterAnyPriority': 'Ktorákoľvek priorita',
  'tickets.filterSource': 'Zdroj',
  'tickets.filterAnySource': 'Ktorýkoľvek zdroj',
  'tickets.filterTicketType': 'Typ tiketu',
  'tickets.filterAnyType': 'Ktorýkoľvek typ',
  'tickets.filterTags': 'Značky',
  'tickets.filterAnyTag': 'Ktorákoľvek značka',
  'tickets.filterCompanies': 'Spoločnosti',
  'tickets.filterAnyCompany': 'Ktorákoľvek spoločnosť',
  'tickets.filterCreated': 'Vytvorené',
  'tickets.filterResolvedAt': 'Vyriešené',
  'tickets.filterClosedAt': 'Zatvorené',
  'tickets.filterDateFrom': '{label} od',
  'tickets.filterDateTo': '{label} do',
  'tickets.filterDateTo2': 'do',
  'tickets.filterAny': 'Ktorýkoľvek',
  'tickets.chipFieldStatus': 'Stav',
  'tickets.chipFieldPriority': 'Priorita',
  'tickets.chipFieldGroup': 'Skupina',
  'tickets.chipFieldAssignee': 'Riešiteľ',
  'tickets.chipValueGroup': 'Skupina',
  'tickets.chipValueUnassigned': 'Nepriradené',
  'common.saving': 'Ukladá sa…',
  'common.clearSearch': 'Vymazať vyhľadávanie',
  'common.sortBy': 'Zoradiť podľa',
  'common.name': 'Meno',
  'common.role': 'Rola',
  'common.groups': 'Skupiny',
  'common.tickets': 'Tikety',
  'common.lastSeen': 'Naposledy videný',
  'common.actions': 'Akcie',
  'common.never': 'Nikdy',
  'common.justNow': 'Práve teraz',
  'common.minutesAgo': 'pred {count} min',
  'common.hoursAgo': 'pred {count} h',
  'common.daysAgo': 'pred {count} d',
  'common.noPagePermission': 'Nemáte oprávnenie na prístup k tejto stránke.',
  'common.roleNoPermission': 'Vaša rola nemá oprávnenie na prístup k tejto stránke.',
  'common.requestFailed': 'Požiadavka zlyhala. Skúste to znova.',
  'common.unexpectedError': 'Vyskytla sa neočakávaná chyba',
  'common.user': 'Používateľ',
  'shell.skipToMain': 'Prejsť na hlavný obsah',
  'shell.homeLabel': 'Domovská stránka Suzuki Support Desk',
  'shell.userMenu': 'Používateľské menu',
  'shell.unread': '{count} neprečítaných',
  'shell.adminNavigation': 'Navigácia administrácie',
  'shell.notificationDescription': 'Nové priradenia, odpovede a upozornenia SLA sa zobrazia tu.',
  'auth.enterAuthenticatorCode': 'Zadajte 6-miestny kód z vašej overovacej aplikácie',
  'auth.verifying': 'Overuje sa…',
  'auth.setupAuthenticator': 'Nastaviť overovaciu aplikáciu',
  'auth.scanAuthenticator': 'Naskenujte tento kód overovacou aplikáciou (Google Authenticator, Authy atď.)',
  'auth.authenticatorSetupQr': 'QR kód na nastavenie overovacej aplikácie',
  'auth.verificationCodeFromAuthenticator': 'Overovací kód z overovacej aplikácie',
  'auth.verifyAndComplete': 'Overiť a dokončiť nastavenie',
  'auth.loadingSetup': 'Načítava sa nastavenie…',
  'auth.setNewPassword': 'Nastaviť nové heslo',
  'auth.temporaryPasswordExpired': 'Vaše dočasné heslo vypršalo. Nastavte si nové heslo.',
  'auth.newPassword': 'Nové heslo',
  'auth.confirmPassword': 'Potvrďte heslo',
  'auth.settingPassword': 'Nastavuje sa heslo…',
  'auth.setPassword': 'Nastaviť heslo',
  'auth.passwordRequirements': 'Vyžaduje sa aspoň 8 znakov, veľké a malé písmeno, číslo a symbol',
  'auth.tooManyAttempts': 'Príliš veľa pokusov o prihlásenie. Skúste to znova neskôr.',
  'auth.invalidCredentials': 'Neplatný e-mail alebo heslo',
  'auth.passwordsDoNotMatch': 'Heslá sa nezhodujú',
  'auth.passwordMinimum': 'Heslo musí mať aspoň {count} znakov',
  'auth.resetTitle': 'Obnovte svoje heslo',
  'auth.resetSubtitle': 'Zadajte svoj e-mail a pošleme vám odkaz na obnovenie',
  'auth.checkEmail': 'Skontrolujte svoj e-mail pre odkaz na obnovenie',
  'auth.checkCode': 'Skontrolujte si e-mail s overovacím kódom a potom pokračujte nižšie.',
  'auth.continueToReset': 'Pokračovať v obnovení hesla',
  'auth.sendResetLink': 'Odoslať odkaz na obnovenie',
  'auth.sending': 'Odosiela sa…',
  'auth.resetSuccess': 'Vaše heslo bolo úspešne obnovené.',
  'auth.goToLogin': 'Prejsť na prihlásenie',
  'auth.missingResetToken': 'Chýba token na obnovenie. Použite odkaz z vášho e-mailu.',
  'auth.enterCodeFromEmail': 'Zadajte overovací kód zaslaný na váš e-mail',
  'auth.codeFromEmail': 'Zadať kód z e-mailu',
  'auth.emailRequired': 'E-mail je povinný',
  'auth.codeRequired': 'Overovací kód je povinný',
  'auth.missingToken': 'Chýba token na obnovenie',
  'auth.failedReset': 'Obnovenie hesla zlyhalo.',
  'auth.resetting': 'Obnovuje sa…',
  'auth.resetPassword': 'Obnoviť heslo',
  'auth.looksGood': 'Vyhovuje',
  'auth.needCharacters': 'Je potrebných aspoň {count} znakov',
  'auth.passwordFormat': 'Vyžaduje sa aspoň {count} znakov, veľké a malé písmeno, číslo a symbol',
  'agents.description': 'Ľudia, ktorí riešia tikety. Priraďte rolu na kontrolu toho, čo môžu robiť, a skupiny na kontrolu toho, čo vidia.',
  'agents.searchAria': 'Hľadať agentov',
  'agents.countOne': '{count} agent',
  'agents.countMany': '{count} agentov',
  'agents.ticketOne': '{count} tiket',
  'agents.ticketMany': '{count} tiketov',
  'agents.noGroups': 'Žiadne skupiny',
  'agents.lifecycle': 'Životný cyklus agenta',
  'agents.noSearchResults': 'Tomuto vyhľadávaniu nezodpovedajú žiadni agenti',
  'agents.noAgentsView': 'V tomto zobrazení nie sú žiadni agenti',
  'agents.tryDifferent': 'Skúste iné meno alebo e-mailovú adresu.',
  'agents.useNewAgent': 'Použite Nový agent na pridanie osoby, alebo prepnite karty na zobrazenie iných agentov.',
  'agents.agent': 'Agent',
  'agents.noRole': 'Žiadna rola',
  'agents.openTicketsTitle': 'Otvorené tikety momentálne priradené tomuto agentovi',
  'agents.moreActions': 'Ďalšie akcie pre {name}',
  'agents.confirmDeleteTitle': 'Odstrániť {name}?',
  'agents.confirmDeleteDescription': 'Toto sa nedá vrátiť späť. Agentov spojených s tiketmi nie je možné odstrániť; deaktivujte ich namiesto toho.',
  'agents.confirmDeleteLabel': 'Odstrániť agenta',
  'agents.agentsVsCollaborators': 'Agenti vs. spolupracovníci',
  'agents.agentsVsCollaboratorsBody': 'Agenti podpory riešia tikety každý deň. Spolupracovníci majú rolu spolupracovníka a sú zvyčajne odborníci prizvaní na jednotlivé tikety bez plného prístupu agenta.',
  'agents.deactivateVsDelete': 'Deaktivácia vs. odstránenie',
  'agents.deactivateVsDeleteBody': 'Deaktivácia zachováva históriu a vlastníctvo tiketov, ale blokuje prihlásenie. Odstránenie je trvalé a funguje iba ak agent nemá žiadne spojené tikety.',
  'agents.newTitle': 'Nový agent',
  'agents.editTitle': 'Upraviť agenta',
  'agents.temporaryPassword': 'Dočasné heslo',
  'agents.passwordHelp': 'Aspoň 12 znakov. Agent to môže zmeniť po prihlásení.',
  'agents.timezoneHelp': 'Každý dátum a čas, ktorý tento agent vidí, sa zobrazuje v tomto časovom pásme.',
  'agents.languageHelp': 'Prekladá rozhranie pre agentov. Odpovede na tikety a obsah klientov sa neprekladajú.',
  'agents.signaturePlaceholder': 'Pripája sa k odchádzajúcim odpovediam',
  'agents.roleHelp': 'Určuje, čo tento agent môže robiť.',
  'agents.manageRoles': 'Správa rolí',
  'agents.activeHelp': 'Aktívny — zrušenie zaškrtnutia blokuje prihlásenie bez odstránenia agenta',
  'agents.groupHelp': 'Pridajte tohto agenta do skupiny na obrazovke Skupiny, aby ste určili, ktoré tikety vidí.',
  'agents.about': 'O tomto agentovi',
  'agents.aboutBody': 'Meno, e-mail, telefón, časové pásmo, jazyk a podpis identifikujú agenta a personalizujú jeho pracovný priestor. Rola určuje, čo môže robiť; členstvo v skupine určuje, ktoré tikety vidí.',
  'dashboard.trendsDescription': 'Vytváranie tiketov podľa hodiny UTC v porovnaní s dneškom.',
  'dashboard.today': 'Dnes',
  'dashboard.yesterday': 'Včera',
  'dashboard.chartAria': 'Objem tiketov podľa hodiny UTC, dnes v porovnaní s včerajškom',
  'dashboard.dataUnavailable': 'Údaje prehľadu nie sú k dispozícii.',
  'dashboard.loadError': 'Nie je možné načítať údaje prehľadu. Skúste to znova.',
  'notifications.noType': 'Žiadne oznámenia tohto typu',
  'notifications.allTypesHint': 'Vyberte „Všetky typy“ vyššie na zobrazenie zvyšku histórie.',
  'notifications.emptyDescription': 'Priradenia, odpovede a upozornenia SLA sa zobrazujú tu. Upravte, ktoré z nich vám posielajú aj e-mail v nastaveniach oznámení.',
  'preferences.digestWarning': 'Máte zapnutý denný prehľad, takže tieto nastavenia sú ignorované, kým ho nevypnete.',
  'preferences.assignedEvent': 'Tiket je vám priradený',
  'preferences.replyEvent': 'Tiket, na ktorom ste, dostane odpoveď',
  'preferences.noteEvent': 'Je pridaná súkromná poznámka',
  'preferences.slaWarningEvent': 'SLA sa blíži k termínu',
  'preferences.slaBreachEvent': 'SLA je porušené',
  'preferences.slaEscalationEvent': 'SLA eskaluje po termíne',
  'preferences.mentionEvent': 'Boli ste spomenutí na tikete',

  'ticketDetail.back': 'Späť',
  'ticketDetail.follow': 'Sledovať',
  'ticketDetail.following': 'Sledované',
  'ticketDetail.hideActivities': 'Skryť aktivity',
  'ticketDetail.activitiesButton': 'Aktivity',
  'ticketDetail.attachmentsCount': 'Prílohy ({count})',
  'ticketDetail.threadAria': 'Vlákno tiketu',
  'ticketDetail.conversationsTabLabel': 'Konverzácie',
  'ticketDetail.activitiesTabLabel': 'Aktivity',
  'ticketDetail.noRepliesYet': 'Zatiaľ žiadne odpovede',
  'ticketDetail.noRepliesDescription': 'Pomocou editora nižšie odpovedzte žiadateľovi alebo pridajte interný poznámku.',
  'ticketDetail.privateNote': 'Súkromná poznámka',
  'ticketDetail.forward': 'Preposlané',
  'ticketDetail.uploadingAria': 'Nahrávanie',
  'ticketDetail.uploadingProgress': 'Nahrávanie {uploading} z {total} súborov…',
  'ticketDetail.uploadsFailed': '{count} nahrávaní sa nepodarilo',
  'ticketDetail.retry': 'Skúsiť znova',
  'ticketDetail.dismiss': 'Zavrieť',
  'ticketDetail.noActivityYet': 'Zatiaľ žiadna aktivita',
  'ticketDetail.noActivityDescription': 'Zmeny stavu, agenta a SLA sa tu zobrazia, ako sa tiket vyvíja.',
  'ticketDetail.requester': 'Žiadateľ',
  'ticketDetail.properties': 'Vlastnosti',
  'ticketDetail.updating': 'Aktualizácia…',
  'ticketDetail.update': 'Aktualizovať',
  'ticketDetail.tags': 'Značky',
  'ticketDetail.relationships': 'Vzťahy',
  'ticketDetail.parentTicket': 'Nadradený tiket',
  'ticketDetail.unlink': 'Odpojiť',
  'ticketDetail.noParentTicket': 'Žiadny nadradený tiket',
  'ticketDetail.childTicketsCount': 'Podradené tikety ({count})',
  'ticketDetail.noChildTickets': 'Žiadne podradené tikety',
  'ticketDetail.findTicket': 'Nájsť tiket',
  'ticketDetail.ticketSearchPlaceholder': 'Číslo tiketu alebo predmet',
  'ticketDetail.searchButton': 'Hľadať',
  'ticketDetail.setParent': 'Nastaviť nadradený',
  'ticketDetail.mergeIntoAction': 'Zlúčiť do',
  'ticketDetail.splitIntoChild': 'Rozdeliť na podradený tiket',
  'ticketDetail.newTicketSubjectPlaceholder': 'Predmet nového tiketu',
  'ticketDetail.splitButton': 'Rozdeliť',
  'ticketDetail.copyAttachments': 'Kopírovať prílohy',
  'ticketDetail.copyConversationHistory': 'Kopírovať históriu konverzácie',
  'ticketDetail.slaLabel': 'SLA',
  'ticketDetail.paused': 'Pozastavené',
  'ticketDetail.editButton': 'Upraviť',
  'ticketDetail.setResolutionDueDate': 'Nastaviť termín vyriešenia',
  'ticketDetail.pickDateTime': 'Vybrať dátum a čas',
  'ticketDetail.resolutionDueLabel': 'Termín vyriešenia',
  'ticketDetail.saveSla': 'Uložiť SLA',
  'ticketDetail.savingSla': 'Ukladanie…',
  'ticketDetail.noSlaPolicy': 'Na tento tiket sa nevzťahuje žiadne pravidlo SLA.',
  'ticketDetail.firstResponse': 'Prvá odpoveď',
  'ticketDetail.resolution': 'Vyriešenie',
  'ticketDetail.done': 'Hotovo',
  'ticketDetail.pausedSince': 'Pozastavené od {date}',
  'ticketDetail.escalation': 'Eskalácia',
  'ticketDetail.escalatedLevel2': 'Eskalované (úroveň 2)',
  'ticketDetail.escalated': 'Eskalované',
  'ticketDetail.dueDateOverridden': 'Termín bol manuálne upravený administrátorom.',
  'ticketDetail.dates': 'Dátumy',
  'ticketDetail.created': 'Vytvorené',
  'ticketDetail.updated': 'Aktualizované',
  'ticketDetail.resolved': 'Vyriešené',
  'ticketDetail.closed': 'Zatvorené',
  'ticketDetail.loadErrorTitle': 'Tento tiket sa nepodarilo načítať',
  'ticketDetail.notFound': 'Tiket nenájdený',
  'ticketDetail.confirmMergeTitle': 'Zlúčiť tiket č. {source} do č. {target}?',
  'ticketDetail.confirmMergeDescription': 'Aktuálny tiket bude zatvorený. Túto akciu nie je možné vrátiť späť.',
  'ticketDetail.confirmMergeLabel': 'Zlúčiť tiket',
  'ticketDetail.updateSuccess': 'Tiket aktualizovaný',
  'ticketDetail.updateError': 'Tiket sa nepodarilo aktualizovať',
  'ticketDetail.pickDateTitle': 'Vyberte dátum',
  'ticketDetail.pickDateDescription': 'Vyberte termín vyriešenia.',
  'ticketDetail.slaUpdateSuccess': 'SLA aktualizované',
  'ticketDetail.slaUpdateError': 'SLA sa nepodarilo aktualizovať',
  'ticketDetail.searchError': 'Tikety sa nepodarilo vyhľadať',
  'ticketDetail.parentUpdateError': 'Nadradený tiket sa nepodarilo aktualizovať',
  'ticketDetail.mergeSuccess': 'Zlúčené do č. {number}',
  'ticketDetail.mergeError': 'Tiket sa nepodarilo zlúčiť',
  'ticketDetail.splitSuccess': 'Rozdelenie tiketu vytvorené',
  'ticketDetail.splitError': 'Tiket sa nepodarilo rozdeliť',
  'ticketDetail.downloadError': 'Prílohu sa nepodarilo stiahnuť',
  'ticketDetail.followSuccess': 'Teraz sledujete tiket',
  'ticketDetail.unfollowSuccess': 'Sledovanie tiketu zastavené',
  'ticketDetail.watcherError': 'Stav sledovania sa nepodarilo aktualizovať',
  'ticketDetail.fieldsLoadError': 'Polia tiketu sa nepodarilo načítať',
  'ticketDetail.overdueBy': 'Po termíne o {label}',
  'ticketDetail.dueLeft': 'Zostáva {label}',
  'ticketDetail.presetToday': 'Dnes',
  'ticketDetail.presetTomorrow': 'Zajtra',
  'ticketDetail.presetThisWeek': 'Tento týždeň',
  'ticketDetail.presetNextWeek': 'Budúci týždeň',
  'ticketDetail.presetThisMonth': 'Tento mesiac',
  'ticketDetail.eventTicketCreated': 'Tiket vytvorený',
  'ticketDetail.eventStatusUpdated': 'Stav aktualizovaný',
  'ticketDetail.eventAgentUpdated': 'Agent aktualizovaný',
  'ticketDetail.eventSlaUpdated': 'SLA aktualizované',
  'ticketDetail.eventTicketMerged': 'Tiket zlúčený',
  'ticketDetail.eventMergeReceived': 'Zlúčenie prijaté',
  'ticketDetail.eventTicketSplit': 'Tiket rozdelený',
  'ticketDetail.eventUpdated': 'Aktualizované',
  'ticketDetail.eventSplitContentCopied': 'Rozdelený obsah skopírovaný',
  'ticketDetail.eventReplySent': 'Odpoveď odoslaná',
  'ticketDetail.eventNoteAdded': 'Poznámka pridaná',
  'ticketDetail.eventCustomerReplied': 'Klient odpovedal',
  'ticketDetail.eventTicketDeleted': 'Tiket vymazaný',
  'preferences.createdEvent': 'Ticket vytvorený',
  'preferences.pendingInputEvent': 'Ticket čaká na vašu odpoveď',
  'preferences.resolvedEvent': 'Ticket je vyriešený',
  'agents.assignGroups': 'Priradiť skupiny',
  'agents.assignGroupsHelp': 'Členstvo v skupinách určuje, ktoré tikety môže tento agent vidieť.',
  'agents.selectGroups': 'Vybrať skupiny',
  'agents.ticketVisibility': 'Viditeľnosť tiketov',
  'agents.ticketVisibilityHelp': 'Vyberte užší rozsah pre agenta alebo použite predvolené nastavenie roly. Oprávnenia roly naďalej určujú, čo môže agent robiť.',
  'agents.scopeRoleDefault': 'Použiť predvolené nastavenie roly',
  'agents.scopeRoleDefaultHelp': 'Použiť predvolenú viditeľnosť nastavenú pre túto rolu.',
  'agents.scopeAll': 'Všetky tikety',
  'agents.scopeAllHelp': 'Zobraziť všetky nevymazané tikety v tomto účte.',
  'agents.scopeGroup': 'Tikety v skupine',
  'agents.scopeGroupHelp': 'Zobraziť tikety priradené skupinám, do ktorých agent patrí.',
  'agents.scopeAssigned': 'Priradené tikety',
  'agents.scopeAssignedHelp': 'Zobraziť tikety priradené priamo tomuto agentovi.',
  'agents.scopeCollaboratorHelp': 'Spolupracovníci zostávajú obmedzení na tikety vo svojich skupinách L1.',
  'nav.jira': 'Integrácia Jira',
  'notifications.groupAssigned': 'Priradenie skupine',
  'notifications.groupMemberAdded': 'Pridaný do skupiny',
  'preferences.groupAssignedEvent': 'Tiket je priradený jednej z vašich skupín',
  'preferences.groupMemberAddedEvent': 'Boli ste pridaný do skupiny podpory',
  'ui.select': 'Vybrať…',
  'ui.any': 'Akékoľvek',
  'ui.typeToSearch': 'Začnite písať a hľadajte…',
  'ui.noResults': 'Nenašli sa žiadne výsledky',
  'ui.clearSelection': 'Zrušiť výber',
  'ui.removeItem': 'Odstrániť {label}',
  'ui.pressEnterToUse': 'Stlačením Enter použijete túto hodnotu',
  'ui.removeFilter': 'Odstrániť filter {field}: {value}',
  'ui.removeTag': 'Odstrániť štítok {label}',
  'ui.retry': 'Skúsiť znova',
  'ui.errorTitle': 'Tento obsah sa nepodarilo načítať',
  'ui.errorMessage': 'Skontrolujte pripojenie a skúste to znova.',
  'ui.reference': 'Referencia: {id}',
  'ui.thisArea': 'táto oblasť',
  'ui.noAccess': 'Nemáte prístup k oblasti {area}',
  'ui.noAccessHint': 'Požiadajte administrátora o pridelenie potrebného oprávnenia.',
  'ui.actionFailed': 'Túto akciu sa nepodarilo dokončiť. Skúste to znova.',
  'ui.slaPaused': 'SLA pozastavené',
  'ui.filteredEmptyTitle': 'Týmto filtrom nezodpovedajú žiadne tikety',
  'ui.filteredEmptyDescription': 'Skúste odstrániť filter alebo rozšíriť časové obdobie.',
  'ui.clearFilters': 'Vymazať filtre',
  'pagination.noResults': 'Žiadne výsledky',
  'pagination.showing': 'Zobrazené {first}–{last} z {total}',
  'pagination.resultsPerPage': 'Výsledkov na stranu',
  'pagination.perPage': '{count} na stranu',
  'pagination.previous': 'Predchádzajúca',
  'pagination.next': 'Ďalšia',
  'pagination.previousAria': 'Predchádzajúca strana',
  'pagination.nextAria': 'Ďalšia strana',
  'pagination.pageOf': 'Strana {page} z {total}',
  'status.open': 'Otvorený',
  'status.to_be_prioritised': 'Čaká na prioritizáciu',
  'status.work_in_progress': 'Rozpracovaný',
  'status.assigned_to_ai_agent': 'Pridelený AI agentovi',
  'status.cto_approval_pending': 'CTO Approval Pending',
  'status.po_approval_pending': 'PO Approval Pending',
  'status.rm_approval_pending': 'RM Approval Pending',
  'status.rework_required': 'Rework Required',
  'status.approved': 'Approved',
  'status.rejected': 'Rejected',
  'status.pending': 'Čaká sa',
  'status.awaiting_user_reply': 'Čaká na odpoveď používateľa',
  'status.awaiting_resolution_confirmation': 'Čaká na potvrdenie vyriešenia',
  'status.on_hold': 'Pozastavený',
  'status.pending_production_release': 'Čaká na nasadenie do produkcie',
  'status.product_cr': 'Produktová CR',
  'status.reopened': 'Znovu otvorený',
  'status.issue_fixed': 'Problém opravený',
  'status.resolved': 'Vyriešený',
  'status.closed': 'Uzavretý',
  'status.unknown': 'Neznámy',
  'priority.low': 'Nízka',
  'priority.medium': 'Stredná',
  'priority.high': 'Vysoká',
  'priority.urgent': 'Naliehavá',
  'source.email': 'E-mail',
  'source.portal': 'Portál',
  'source.phone': 'Telefón',
  'source.chat': 'Chat',
  'source.whatsapp': 'WhatsApp',
  'source.web_chat': 'Webový chat',
  'source.web_form': 'Webový formulár',
  'source.forum': 'Fórum',
  'source.facebook': 'Facebook',
  'source.mobihelp': 'MobiHelp',
  'source.feedback_widget': 'Widget spätnej väzby',
  'source.outbound_email': 'Odchádzajúci e-mail',
  'source.ecommerce': 'E-shop',
  'source.bot': 'Bot',
  'source.instagram_message': 'Správa na Instagrame',
  'source.instagram_comment': 'Komentár na Instagrame',
  'source.facebook_message': 'Správa na Facebooku',
  'source.facebook_comment': 'Komentár na Facebooku',
  'source.mobile_chat_sdk': 'Mobilné chat SDK',
  'source.sms': 'SMS',
  'source.api': 'API',
  'savedViews.title': 'Uložené zobrazenia',
  'savedViews.saveCurrent': 'Uložiť aktuálne filtre ako zobrazenie',
  'savedViews.namePlaceholder': 'Názov zobrazenia...',
  'savedViews.nameAria': 'Názov zobrazenia',
  'savedViews.empty': 'Žiadne uložené zobrazenia. Použite filtre a uložte ich tu.',
  'savedViews.listAria': 'Zoznam uložených zobrazení',
  'savedViews.rename': 'Premenovať zobrazenie „{name}“',
  'savedViews.delete': 'Odstrániť zobrazenie „{name}“',
  'export.title': 'Exportovať tikety',
  'export.loadError': 'Zoznam polí na export sa nepodarilo načítať.',
  'export.failed': 'Export zlyhal. Skúste to prosím znova.',
  'export.pdfFailed': 'Export do PDF zlyhal. Skúste to prosím znova.',
  'export.fieldsSelectedOne': 'Vybrané {count} pole',
  'export.fieldsSelectedMany': 'Vybrané polia: {count}',
  'export.fieldsTotalOne': '{count} pole celkom',
  'export.fieldsTotalMany': 'Polí celkom: {count}',
  'export.selectAllFields': 'Vybrať všetky polia',
  'export.exportingOne': 'Exportuje sa 1 vybraný tiket.',
  'export.exportingMany': 'Exportuje sa vybraných tiketov: {count}.',
  'export.pdfZip': 'Stiahnuť ako PDF (.zip, súborov: {count})',
  'export.pdf': 'Stiahnuť ako PDF',
  'export.pdfZipHint': 'Vytvorí jeden PDF súbor pre každý tiket a zabalí ich do jedného súboru ZIP na stiahnutie.',
  'export.pdfHint': 'Vytvorí jeden PDF súbor s vlastnosťami tiketu a verejným vláknom konverzácie.',
  'export.formatLabel': 'Exportovať ako (CSV / Excel)',
  'export.csv': 'CSV',
  'export.excel': 'Excel',
  'export.loadingFields': 'Načítava sa zoznam polí…',
  'export.ticketFields': 'Polia tiketu',
  'export.contactFields': 'Polia kontaktu',
  'export.companyFields': 'Polia spoločnosti',
  'export.exporting': 'Exportuje sa…',
  'newTicket.title': 'Vytvoriť tiket',
  'newTicket.description': 'Vyberte uložený formulár a vyplňte jeho polia.',
  'newTicket.form': 'Formulár tiketu',
  'newTicket.noForms': 'Nie sú k dispozícii žiadne formuláre tiketov. Pred vytvorením tiketu nastavte formulár.',
  'newTicket.loadFormsError': 'Formuláre tiketov sa nepodarilo načítať',
  'newTicket.loadFormError': 'Vybraný formulár tiketu sa nepodarilo načítať',
  'newTicket.addCc': 'Pridať CC',
  'newTicket.cc': 'CC',
  'newTicket.removeFile': 'Odstrániť {name}',
  'newTicket.requesterRequired': 'Žiadateľ je povinný',
  'newTicket.subjectRequired': 'Predmet je povinný',
  'newTicket.createFailed': 'Tiket sa nepodarilo vytvoriť',
  'newTicket.noFormTitle': 'Nie je k dispozícii žiadny formulár tiketu',
  'newTicket.noFormDescription': 'Vytvorte formulár tiketu v Nastaveniach a potom sa vráťte a otvorte tiket.',
  'newTicket.noFieldsTitle': 'Tento formulár zatiaľ nemá žiadne polia',
  'newTicket.noFieldsDescription': 'Pridajte polia do formulára v Nastaveniach a potom túto stránku znova načítajte.',
  'newTicket.creating': 'Vytvára sa...',
  'newTicket.submit': 'Vytvoriť tiket',
  'fields.required': '{label} je povinné',
  'fields.selectParentFirst': 'Najprv vyberte nadradenú hodnotu...',
  'fields.selectPlaceholder': 'Vyberte {label}...',
  'fields.enterPlaceholder': 'Zadajte {label}...',
  'fields.optionsLoadError': 'Možnosti pre {label} sa nepodarilo načítať',
  'fields.label.requester': 'Žiadateľ',
  'fields.label.subject': 'Predmet',
  'fields.label.description': 'Popis',
  'fields.label.status': 'Stav',
  'fields.label.priority': 'Priorita',
  'fields.label.source': 'Zdroj',
  'fields.label.ticket_type': 'Typ',
  'fields.label.agent': 'Agent',
  'fields.label.group': 'Skupina',
  'fields.label.internal_agent': 'Interný agent',
  'fields.label.internal_group': 'Interná skupina',
  'fields.label.company': 'Spoločnosť',
  'editor.defaultPlaceholder': 'Píšte tu...',
  'editor.ariaLabel': 'Editor formátovaného textu',
  'editor.toolbarAria': 'Formátovanie textu',
  'editor.bold': 'Tučné (Ctrl+B)',
  'editor.italic': 'Kurzíva (Ctrl+I)',
  'editor.underline': 'Podčiarknuté (Ctrl+U)',
  'editor.strikethrough': 'Prečiarknuté',
  'editor.heading1': 'Nadpis 1',
  'editor.heading2': 'Nadpis 2',
  'editor.textColor': 'Farba textu',
  'editor.highlight': 'Zvýraznenie',
  'editor.bulletList': 'Odrážkový zoznam',
  'editor.numberedList': 'Číslovaný zoznam',
  'editor.blockquote': 'Citácia',
  'editor.codeBlock': 'Blok kódu',
  'editor.insertLink': 'Vložiť odkaz',
  'editor.insertImage': 'Vložiť obrázok',
  'editor.insertTable': 'Vložiť tabuľku',
  'editor.mention': 'Spomenúť niekoho',
  'editor.undo': 'Späť (Ctrl+Z)',
  'editor.redo': 'Znova (Ctrl+Shift+Z)',
  'editor.attach': 'Priložiť súbor',
  'editor.noAgents': 'Nenašli sa žiadni agenti',
  'editor.mentionSuggestions': 'Návrhy na spomenutie',
  'editor.dialogLinkTitle': 'Vložiť odkaz',
  'editor.dialogImageTitle': 'Vložiť obrázok',
  'editor.linkHint': 'Zadajte adresu URL HTTP(S), mailto, kotvu alebo relatívnu adresu URL.',
  'editor.imageHint': 'Zadajte adresu URL obrázka HTTP(S) alebo relatívnu.',
  'editor.url': 'URL',
  'editor.invalidLink': 'Zadajte platnú adresu URL HTTP(S), mailto, kotvu alebo relatívnu adresu URL.',
  'editor.invalidImage': 'Zadajte platnú adresu URL obrázka HTTP(S) alebo relatívnu.',
  'editor.selectTextForLink': 'Pred pridaním odkazu vyberte text.',
  'editor.imageInsertFailed': 'Obrázok sa sem nepodarilo vložiť.',
  'editor.insertLinkAction': 'Vložiť odkaz',
  'editor.insertImageAction': 'Vložiť obrázok',
  'search.dialogAria': 'Globálne vyhľadávanie',
  'search.placeholder': 'Hľadať tikety, kontakty...',
  'search.aria': 'Hľadať',
  'search.close': 'Zavrieť vyhľadávanie',
  'search.noMatches': 'Žiadne zhody pre „{query}“',
  'search.noMatchesHint': 'Skúste číslo tiketu, e-mail kontaktu alebo názov spoločnosti.',
  'search.hintBefore': 'Na vyhľadávanie zadajte aspoň 2 znaky. Stlačením',
  'search.hintAfter': 'zavriete.',

  'td.system': 'Systém',
  'td.actionCreatedTicket': 'vytvoril(a) tiket',
  'td.actionUpdatedFields': 'aktualizoval(a) {fields}',
  'td.fieldStatus': 'stav',
  'td.fieldPriority': 'prioritu',
  'td.fieldSource': 'zdroj',
  'td.fieldType': 'typ',
  'td.fieldGroup': 'skupinu',
  'td.fieldAgent': 'agenta',
  'td.fieldCompany': 'spoločnosť',
  'td.fieldContact': 'kontakt',
  'td.fieldSubject': 'predmet',
  'td.fieldDescription': 'popis',
  'td.fieldProduct': 'produkt',
  'td.fieldResolutionDue': 'termín vyriešenia',
  'td.fieldFirstResponseDue': 'termín prvej odpovede',
  'td.fieldTags': 'značky',
  'td.fieldParentTicket': 'nadradený tiket',
  'td.eventCreated': '{actor} vytvoril(a) nový tiket',
  'td.eventCreatedLinked': '{actor} vytvoril(a) nový tiket a prepojil(a) ho s nadradeným tiketom',
  'td.eventSplit': '{actor} rozdelil(a) tento tiket a vytvoril(a) podradený tiket{ref}',
  'td.eventMergeReceived': '{actor} zlúčil(a) iný tiket do tohto tiketu{ref}',
  'td.eventMerged': '{actor} zlúčil(a) tento tiket do iného tiketu{ref}',
  'td.eventSplitCopied': '{actor} skopíroval(a) {conversations} a {attachments}',
  'td.conversationsOne': '{count} konverzácia',
  'td.conversationsMany': '{count} konverzácií',
  'td.attachmentsOne': '{count} príloha',
  'td.attachmentsMany': '{count} príloh',
  'td.eventUpdatedFields': '{actor} aktualizoval(a) {fields}',
  'td.invalidSlaState': 'Server vrátil neplatný stav SLA.',
  'td.slaRefreshError': 'Časovače SLA sa nepodarilo obnoviť.',
  'td.descriptionUpdated': 'Popis bol aktualizovaný',
  'td.descriptionUpdateError': 'Popis sa nepodarilo aktualizovať',
  'td.descriptionUpdateFailed': 'Aktualizácia popisu zlyhala',
  'td.entryUpdated': 'Záznam bol aktualizovaný',
  'td.entryUpdateError': 'Záznam sa nepodarilo aktualizovať',
  'td.updateFailed': 'Aktualizácia zlyhala',
  'td.loadOlderError': 'Staršie konverzácie sa nepodarilo načítať',
  'td.loadFailed': 'Načítanie zlyhalo',
  'td.slaUpdateFailed': 'Aktualizácia SLA zlyhala',
  'td.reasonTooLong': 'Dôvod môže mať najviac 500 znakov.',
  'td.invalidDateTime': 'Vyberte platný dátum a čas.',
  'td.slaDeadlineUpdated': 'Termín SLA bol aktualizovaný',
  'td.slaConflict': 'Tiket sa zmenil počas úpravy údajov SLA. Pred ďalším pokusom ho znova načítajte.',
  'td.slaClearFailed': 'Zrušenie SLA zlyhalo',
  'td.slaTargetCleared': 'Cieľ SLA bol zrušený',
  'td.slaClearError': 'Cieľ SLA sa nepodarilo zrušiť',
  'td.noDescription': 'Zatiaľ nebol pridaný žiadny popis.',
  'td.editDescriptionAria': 'Upraviť popis tiketu',
  'td.download': 'Stiahnuť',
  'td.downloadFile': 'Stiahnuť {fileName}',
  'td.loadOlder': '↓ +{count} konverzácia',
  'td.loadOlderMany': '↓ +{count} konverzácií',
  'td.edited': '(upravené)',
  'td.privateThread': 'Súkromné vlákno',
  'td.propertiesAria': 'Vlastnosti tiketu',
  'td.expandProperties': 'Rozbaliť vlastnosti',
  'td.collapseProperties': 'Zbaliť vlastnosti',
  'td.metric': 'Metrika',
  'td.firstResponseOption': 'Prvá odpoveď',
  'td.resolutionOption': 'Vyriešenie',
  'td.overrideHint': 'Nastavte termín, ktorý prepíše hodnotu zo servera. Dôvod sa uchová v histórii SLA.',
  'td.deadline': 'Termín',
  'td.reasonOptional': 'Dôvod (voliteľné)',
  'td.reasonPlaceholder': 'Schválená výnimka alebo prevádzkový kontext',
  'td.clearResolutionOverride': 'Zrušiť prepísanie vyriešenia',
  'td.clearEscalationTarget': 'Zrušiť cieľ eskalácie',
  'td.toolsAria': 'Nástroje tiketu a kontakt',
  'td.ticketContext': 'Kontext tiketu',
  'td.knowledgeBase': 'Znalostná databáza',
  'td.shortcutsAria': 'Skratky kontextu tiketu',
  'td.showContext': 'Zobraziť kontext tiketu',
  'td.hideContext': 'Skryť kontext tiketu',
  'td.openRow': 'Otvoriť {label}',
  'td.editTicket': 'Upraviť tiket',
  'td.searchContactPlaceholder': 'Hľadať kontakt…',
  'td.describePlaceholder': 'Opíšte problém…',
  'td.noAttachments': 'Žiadne prílohy',

  'tp.api.csrfUnavailable': 'Ochranu CSRF sa nepodarilo vytvoriť',
  'tp.api.noMfaChallenge': 'Nie je aktívna žiadna výzva MFA',
  'tp.api.noMfaSetup': 'Nie je aktívna žiadna výzva na nastavenie MFA',
  'tp.api.noNewPasswordChallenge': 'Nie je aktívna žiadna výzva na nové heslo',
  'tp.articles.isLinkedAria': '{title} je prepojený ako riešenie',
  'tp.articles.linkAria': 'Prepojiť {title} ako riešenie',
  'tp.articles.linkAsSolution': 'Prepojiť ako riešenie',
  'tp.articles.linkedAsSolution': 'Prepojené ako riešenie',
  'tp.articles.none': 'Pre tento tiket nie sú žiadne navrhované články.',
  'tp.articles.title': 'Navrhované články',
  'tp.articles.views': '{count} zobrazení',
  'tp.attachment.loadingPreview': 'Načítava sa náhľad…',
  'tp.attachment.previewUnavailable': 'Náhľad nie je k dispozícii',
  'tp.charts.noData': 'Pre toto obdobie nie sú žiadne údaje grafu.',
  'tp.charts.noRecords': 'V tomto období nie sú žiadne záznamy.',
  'tp.charts.period': 'Obdobie',
  'tp.charts.showingTop': 'Zobrazuje sa prvých {shown} z {total} segmentov.',
  'tp.common.cancel': 'Zrušiť',
  'tp.common.clear': 'Vymazať',
  'tp.common.loading': 'Načítava sa…',
  'tp.common.send': 'Odoslať',
  'tp.common.sending': 'Odosiela sa…',
  'tp.common.system': 'Systém',
  'tp.convActions.edit': 'Upraviť',
  'tp.convActions.thread': 'Začať vlákno',
  'tp.dashboard.new': 'Nový',
  'tp.dashboard.select': 'Vybrať prehľad',
  'tp.forward.failed': 'Preposlanie zlyhalo',
  'tp.forward.forwarded': 'Tiket bol preposlaný',
  'tp.forward.forwarding': 'Preposiela sa…',
  'tp.forward.forwardingMany': 'Preposielanie konverzácií ({count}):',
  'tp.forward.forwardingOne': 'Preposielanie 1 konverzácie:',
  'tp.forward.message': 'Správa',
  'tp.forward.messagePlaceholder': 'Pridajte správu (voliteľné)…',
  'tp.forward.noContacts': 'Nenašli sa žiadne kontakty — zadajte úplnú e-mailovú adresu',
  'tp.forward.recipientEmail': 'E-mail príjemcu',
  'tp.forward.recipientInvalid': 'Zadajte platnú e-mailovú adresu príjemcu',
  'tp.forward.recipientRequired': 'E-mail príjemcu je povinný',
  'tp.forward.searchContact': 'Hľadajte kontakt alebo zadajte e-mail…',
  'tp.forward.title': 'Preposlať',
  'tp.forward.to': 'Komu',
  'tp.forward.useThisEmail': 'Stlačte Enter alebo kliknite na Preposlať, aby ste použili tento e-mail',
  'tp.jira.addOptional': 'Pridať voliteľné polia',
  'tp.jira.createAndLink': 'Vytvoriť a prepojiť problém',
  'tp.jira.createIssue': 'Vytvoriť problém',
  'tp.jira.createTitle': 'Vytvoriť problém v Jira',
  'tp.jira.describePlaceholder': 'Opíšte problém…',
  'tp.jira.description': 'Popis',
  'tp.jira.development': 'Vývoj',
  'tp.jira.enterDevelopment': 'Zadajte vývoj',
  'tp.jira.hideOptional': 'Skryť voliteľné polia',
  'tp.jira.issueId': 'ID problému',
  'tp.jira.issueSummary': 'Súhrn problému',
  'tp.jira.issueType': 'Typ problému *',
  'tp.jira.lastSync': 'Posledná synchronizácia: {error}',
  'tp.jira.linkIssue': 'Prepojiť problém',
  'tp.jira.linkTitle': 'Prepojiť problém z Jira',
  'tp.jira.linkedIssues': 'Prepojené problémy',
  'tp.jira.linkedIssuesHint': 'Použite kľúče problémov z Jira oddelené čiarkami.',
  'tp.jira.linkedIssuesPlaceholder': 'napr. SUP-123, SUP-456',
  'tp.jira.loadingFields': 'Načítavajú sa polia Jira…',
  'tp.jira.loadingIssueTypes': 'Načítavajú sa typy problémov…',
  'tp.jira.loadingProjects': 'Načítavajú sa projekty Jira…',
  'tp.jira.loadingUsers': 'Načítavajú sa používatelia Jira…',
  'tp.jira.noLinks': 'S týmto tiketom zatiaľ nie sú prepojené žiadne problémy z Jira.',
  'tp.jira.noneFound': 'Nenašli sa žiadne problémy z Jira.',
  'tp.jira.notAvailableProject': 'Pre tento projekt nie je k dispozícii',
  'tp.jira.projects': 'Projekty *',
  'tp.jira.refresh': 'Obnoviť',
  'tp.jira.refreshFields': 'Obnoviť polia Jira',
  'tp.jira.reporter': 'Zadávateľ',
  'tp.jira.requestFailed': 'Požiadavka na Jira zlyhala. Skúste to znova.',
  'tp.jira.searchBy': 'Hľadať podľa:',
  'tp.jira.searchIssue': 'Hľadať problém',
  'tp.jira.searchIssuePlaceholder': 'Hľadať problém…',
  'tp.jira.searchUsers': 'Hľadať používateľov Jira',
  'tp.jira.searching': 'Hľadá sa v Jira…',
  'tp.jira.selectIssueType': 'Vyberte typ problému',
  'tp.jira.selectProject': 'Vyberte projekt',
  'tp.jira.summary': 'Súhrn *',
  'tp.jira.syncOff': 'Synchronizácia vypnutá',
  'tp.jira.syncOn': 'Synchronizácia zapnutá',
  'tp.jira.syncStatus': 'Synchronizovať stav tiketu do Jira',
  'tp.jira.unassigned': 'Nepriradené',
  'tp.jira.unlink': 'Odpojiť',
  'tp.jira.unlinkConfirm': 'Odpojiť problém',
  'tp.jira.unlinkDescription': 'Tým sa odstráni prepojenie s tiketom, ale problém v Jira sa neodstráni.',
  'tp.jira.unlinkTitle': 'Odpojiť {key}?',
  'tp.jira.untitled': 'Problém Jira bez názvu',
  'tp.layout.loadingPage': 'Načítava sa stránka…',
  'tp.notFound.goToDashboard': 'Prejsť na prehľad',
  'tp.notFound.title': 'Stránka nenájdená',
  'tp.portal.brand': 'Podpora SuzukiDesk',
  'tp.portal.customer': 'Zákazník',
  'tp.reply.addNote': 'Pridať poznámku',
  'tp.reply.attachmentNotAdded': 'Príloha nebola pridaná',
  'tp.reply.clickToExpand': 'Kliknutím rozbalíte',
  'tp.reply.collapsedNote': 'Pridať internú poznámku…',
  'tp.reply.collapsedReply': 'Napísať odpoveď alebo poznámku…',
  'tp.reply.conversationType': 'Typ konverzácie',
  'tp.reply.failedToSend': 'Odoslanie zlyhalo',
  'tp.reply.markNoteAs': 'Označiť poznámku ako',
  'tp.reply.notVisibleToContact': 'Nie je viditeľné pre kontakt',
  'tp.reply.notVisibleToContacts': 'Nie je viditeľné pre kontakty',
  'tp.reply.noteAdded': 'Poznámka bola pridaná',
  'tp.reply.notifyTo': 'Oznámiť',
  'tp.reply.placeholderPrivateNote': 'Pridajte súkromnú poznámku...',
  'tp.reply.placeholderPublicNote': 'Pridajte verejnú poznámku viditeľnú pre žiadateľa...',
  'tp.reply.placeholderReply': 'Napíšte svoju odpoveď...',
  'tp.reply.private': 'Súkromné',
  'tp.reply.public': 'Verejné',
  'tp.reply.removeFile': 'Odstrániť {name}',
  'tp.reply.replySent': 'Odpoveď bola odoslaná',
  'tp.reply.searchAgentsToNotify': 'Hľadať agentov na oznámenie…',
  'tp.reply.sendReply': 'Odoslať odpoveď',
  'tp.reply.sending': 'Odosiela sa...',
  'tp.reply.tabNote': 'Poznámka',
  'tp.reply.tabReply': 'Odpoveď',
  'tp.reply.uploadAttachment': 'Nahrať prílohu',
  'tp.reply.visibleToContact': 'Viditeľné pre kontakt',
  'tp.reply.visibleToContacts': 'Viditeľné pre kontakty',
  'tp.sla.breached': 'Porušené',
  'tp.sla.cleared': 'Zrušené',
  'tp.sla.configErrorNoDeadline': 'Chyba konfigurácie SLA. Termín sa neodvodzuje.',
  'tp.sla.configurationError': 'Chyba konfigurácie',
  'tp.sla.couldNotLoad': 'Časovače SLA sa nepodarilo načítať',
  'tp.sla.done': 'Hotovo',
  'tp.sla.dueIn': 'Termín za {duration}',
  'tp.sla.dueLine': 'Termín: {date}',
  'tp.sla.dueNow': 'Termín nastal',
  'tp.sla.escalated': 'Eskalované',
  'tp.sla.firstResponse': 'Prvá odpoveď',
  'tp.sla.invalidDeadline': 'Neplatný termín',
  'tp.sla.mayBeStale': 'Časovače SLA môžu byť neaktuálne',
  'tp.sla.noActiveCycle': 'Žiadny aktívny cyklus SLA.',
  'tp.sla.noDeadline': 'Bez termínu',
  'tp.sla.noMetrics': 'Pre tento cyklus nie sú k dispozícii žiadne metriky SLA.',
  'tp.sla.noPolicy': 'Na tento tiket sa nevzťahuje žiadne pravidlo SLA.',
  'tp.sla.notConfigured': 'Nenakonfigurované',
  'tp.sla.notStarted': 'Nezačalo',
  'tp.sla.overdueBy': 'Po termíne o {duration}',
  'tp.sla.overridden': 'Prepísané',
  'tp.sla.overrideReason': 'Dôvod prepísania: {reason}',
  'tp.sla.paused': 'Pozastavené',
  'tp.sla.refreshing': 'Obnovujú sa autoritatívne časovače SLA…',
  'tp.sla.resolution': 'Vyriešenie',
  'tp.sla.stopsSla': 'Zastavuje SLA',
  'tp.thread.empty': 'Zatiaľ nebolo nič odoslané. Vaša prvá správa začne toto súkromné vlákno.',
  'tp.thread.messageFailed': 'Správa zlyhala',
  'tp.thread.privateThread': 'Súkromné vlákno',
  'tp.thread.replyPlaceholder': 'Odpovedať vo vlákne…',
  'tp.thread.someone': 'Niekto',
  'tp.thread.startPrivateThread': 'Začať súkromné vlákno',
  'tp.thread.startedBy': '{name} začal(a) toto vlákno',
  'tp.thread.unableToSend': 'Správu sa nepodarilo odoslať',
  'tp.ui.breadcrumb': 'Navigačná cesta',
  'tp.ui.closePanel': 'Zavrieť panel',
  'tp.ui.dismiss': 'Zavrieť {title}',

  'dir.loadError': 'Údaje sa nepodarilo načítať. Skúste to znova.',
  'dir.contacts.description': 'Kontakty zákazníkov a ich história podpory.',
  'dir.contacts.searchAria': 'Hľadať kontakty',
  'dir.contacts.count': 'Kontakty: {count}',
  'dir.contacts.noMatch': 'Tomuto vyhľadávaniu nezodpovedajú žiadne kontakty',
  'dir.contacts.none': 'Zatiaľ žiadne kontakty',
  'dir.contacts.noneDescription': 'Kontakty sa tu zobrazia, keď zákazníci začnú odosielať tikety.',
  'dir.company': 'Spoločnosť',
  'dir.unnamedContact': 'Kontakt bez mena',
  'dir.contact': 'Kontakt',
  'dir.contactNotFound': 'Kontakt nenájdený.',
  'dir.confirmDeleteContactTitle': 'Odstrániť „{name}“?',
  'dir.thisContact': 'tento kontakt',
  'dir.confirmDeleteContactDescription': 'Kontakty s tiketmi sa namiesto trvalého odstránenia deaktivujú.',
  'dir.deleteContact': 'Odstrániť kontakt',
  'dir.editProfile': 'Upraviť profil',
  'dir.profile': 'Profil',
  'dir.firstName': 'Meno',
  'dir.lastName': 'Priezvisko',
  'dir.phone': 'Telefón',
  'dir.timezone': 'Časové pásmo',
  'dir.emailLabel': 'E-mail:',
  'dir.phoneLabel': 'Telefón:',
  'dir.companyLabel': 'Spoločnosť:',
  'dir.timezoneLabel': 'Časové pásmo:',
  'dir.recentTickets': 'Nedávne tikety',
  'dir.noTicketsYet': 'Zatiaľ žiadne tikety',
  'dir.contactTicketsDescription': 'Tikety, ktoré zadal tento kontakt, sa zobrazia tu.',
  'dir.ticket': 'Tiket',
  'dir.subject': 'Predmet',
  'dir.status': 'Stav',
  'dir.created': 'Vytvorené',
  'dir.companies.description': 'Organizácie prepojené s kontaktmi zákazníkov a tiketmi.',
  'dir.companies.add': 'Pridať spoločnosť',
  'dir.companies.domain': 'Doména',
  'dir.companies.create': 'Vytvoriť spoločnosť',
  'dir.companies.searchAria': 'Hľadať spoločnosti',
  'dir.companies.searchPlaceholder': 'Hľadať spoločnosti alebo domény',
  'dir.companies.noMatch': 'Tomuto vyhľadávaniu nezodpovedajú žiadne spoločnosti',
  'dir.companies.addFirst': 'Pridajte svoju prvú spoločnosť',
  'dir.companies.tryDifferent': 'Skúste iný názov spoločnosti alebo doménu.',
  'dir.companies.useForm': 'Na vytvorenie spoločnosti použite formulár vedľa tohto zoznamu.',
  'dir.companies.contacts': 'Kontakty',
  'dir.companies.tickets': 'Tikety',
  'dir.companies.notFound': 'Spoločnosť nenájdená.',
  'dir.companies.confirmDeleteTitle': 'Odstrániť „{name}“?',
  'dir.companies.thisCompany': 'táto spoločnosť',
  'dir.companies.confirmDeleteDescription': 'Spoločnosť nesmie mať žiadne kontakty ani tikety, aby ju bolo možné odstrániť.',
  'dir.companies.delete': 'Odstrániť spoločnosť',
  'dir.companies.noDomain': 'Nie je nastavená žiadna doména',
  'dir.companies.contactsCount': 'Kontakty ({count})',
  'dir.companies.ticketsCount': 'Tikety ({count})',
  'dir.companies.noContactsDescription': 'Pridajte kontakt a prepojte ho s touto spoločnosťou, aby sa zobrazil tu.',
  'dir.companies.noTicketsDescription': 'Tikety, ktoré zadali kontakty tejto spoločnosti, sa zobrazia tu.',
  'dir.trendsCreatedHour': 'Dátum vytvorenia – hodina dňa',
  'dir.reports.loadError': 'Tento prehľad sa nepodarilo načítať. Skúste to znova.',
  'dir.reports.volume': 'Objem tiketov',
  'dir.reports.sla': 'Dodržiavanie SLA',
  'dir.reports.agents': 'Výkonnosť agentov',
  'dir.reports.csat': 'Spokojnosť zákazníkov',
  'dir.reports.rca': 'Analýza základnej príčiny',
  'dir.reports.descVolume': 'Zistite, odkiaľ tikety prichádzajú a ako prechádzajú životným cyklom.',
  'dir.reports.descSla': 'Sledujte ciele odpovede a vyriešenia v rámci prístupnej podpornej prevádzky.',
  'dir.reports.descAgents': 'Porovnajte pracovné zaťaženie, výsledky, odpovede a priemerné časy spracovania podľa agenta.',
  'dir.reports.descCsat': 'Sledujte spokojnosť zákazníkov bez zámeny počtu odpovedí s mierou spokojnosti.',
  'dir.reports.descRca': 'Nájdite štandardizované základné príčiny dopytu po tiketoch.',
  'dir.reports.noPayload': 'Pre toto obdobie sa nevrátili žiadne údaje prehľadu.',
  'dir.reports.refresh': 'Obnoviť',
  'dir.reports.report': 'Prehľad',
  'dir.reports.from': 'Od',
  'dir.reports.to': 'Do',
  'dir.reports.maxRange': 'Maximálny rozsah: 90 dní · rozsah zodpovedá oprávneniam vášho účtu.',
  'dir.reports.unclassified': 'Nezaradené',
  'dir.reports.ticketsInPeriod': 'Tikety v období',
  'dir.reports.ticketsInPeriodDetail': 'Prístupné tikety vrátené prehľadom',
  'dir.reports.created': 'Vytvorené',
  'dir.reports.createdDetail': 'Na vybranej osi dátumov',
  'dir.reports.resolved': 'Vyriešené',
  'dir.reports.resolvedDetail': '{percent} % vytvoreného objemu',
  'dir.reports.noCreated': 'Žiadne vytvorené tikety',
  'dir.reports.reopened': 'Znovu otvorené',
  'dir.reports.reopenedDetail': 'Udalosti životného cyklu, nie jedinečné tikety',
  'dir.reports.dailyPulse': 'Denný pulz',
  'dir.reports.volumeByDate': 'Objem tiketov podľa dátumu',
  'dir.reports.volumeByDateDescription': 'Riedke riadky z backendu sa rozšíria na úplnú os dátumov doplnenú nulami.',
  'dir.reports.createdTickets': 'Vytvorené tikety',
  'dir.reports.createdVolumeAria': 'Objem vytvorených tiketov podľa dátumu',
  'dir.reports.lifecycle': 'Životný cyklus',
  'dir.reports.lifecycleTitle': 'Vytvorené, vyriešené, znovu otvorené',
  'dir.reports.lifecycleDescription': 'Trojčiarový pohľad na pohyb tiketov životným cyklom.',
  'dir.reports.lifecycleAria': 'Udalosti životného cyklu tiketov podľa dátumu',
  'dir.reports.dimensions': 'Dimenzie',
  'dir.reports.whereConcentrated': 'Kde je objem sústredený',
  'dir.reports.topEight': 'V každom paneli je zobrazených osem najväčších segmentov',
  'dir.reports.status': 'Stav',
  'dir.reports.statusDescription': 'Aktuálny stav tiketu',
  'dir.reports.priority': 'Priorita',
  'dir.reports.priorityDescription': 'Zloženie priorít tiketov',
  'dir.reports.group': 'Skupina',
  'dir.reports.groupDescription': 'Smerovacie skupiny',
  'dir.reports.agent': 'Agent',
  'dir.reports.agentDescription': 'Priradené vlastníctvo',
  'dir.reports.product': 'Produkt',
  'dir.reports.productDescription': 'Zloženie produktov',
  'dir.reports.country': 'Krajina',
  'dir.reports.countryDescription': 'Zo štandardizovaných polí krajiny',
  'dir.reports.noRecords': 'V tomto období nie sú žiadne záznamy.',
  'dir.reports.slaSummary': '{rate} · splnených {met} z {total}',
  'dir.reports.noSlaSegments': 'Zatiaľ žiadne segmenty SLA',
  'dir.reports.noSlaSegmentsDescription': 'Pre túto dimenziu nie sú vo vybranom období žiadne použiteľné záznamy SLA.',
  'dir.reports.segment': 'Segment',
  'dir.reports.firstResponse': 'Prvá odpoveď',
  'dir.reports.resolution': 'Vyriešenie',
  'dir.reports.avgFirstResponse': 'Priem. prvá odpoveď',
  'dir.reports.avgResolution': 'Priem. vyriešenie',
  'dir.reports.fromTicketMetric': 'Z TicketMetric',
  'dir.reports.slaLens': 'Pohľad SLA',
  'dir.reports.performanceBySegment': 'Výkonnosť podľa segmentu',
  'dir.reports.slaRatesNote': 'Miery používajú iba záznamy s použiteľným cieľom SLA. Trvania sú priemerný uplynulý čas.',
  'dir.reports.slaDimensionAria': 'Dimenzia rozdelenia SLA',
  'dir.reports.rosterSignal': 'Prehľad tímu',
  'dir.reports.agentPerformance': 'Výkonnosť agentov',
  'dir.reports.agentPerformanceDescription': 'Zahrnutí sú všetci aktívni agenti vrátane agentov bez aktivity.',
  'dir.reports.filterAgentsAria': 'Filtrovať agentov',
  'dir.reports.filterAgentsPlaceholder': 'Filtrovať podľa agenta alebo e-mailu',
  'dir.reports.matchingAgents': 'Zodpovedajúci agenti: {count}',
  'dir.reports.activeAgents': 'Aktívni agenti: {count}',
  'dir.reports.sortedBy': 'zoradené podľa {key} {direction}',
  'dir.reports.asc': 'vzostupne',
  'dir.reports.desc': 'zostupne',
  'dir.reports.noAgentsMatch': 'Tomuto filtru nezodpovedajú žiadni agenti',
  'dir.reports.assigned': 'Priradené',
  'dir.reports.replies': 'Odpovede',
  'dir.reports.csatScore': 'Skóre CSAT',
  'dir.reports.csatScoreDetail': 'Hodnotenia 4 alebo 5',
  'dir.reports.averageRating': 'Priemerné hodnotenie',
  'dir.reports.averageRatingDetail': 'Naprieč ohodnotenými prieskumami',
  'dir.reports.ratedSurveys': 'Ohodnotené prieskumy',
  'dir.reports.ratedSurveysDetail': 'Vo vybranom období',
  'dir.reports.satisfied': 'Spokojní',
  'dir.reports.satisfiedDetail': 'Pozitívne odpovede',
  'dir.reports.responseTrend': 'Trend odpovedí',
  'dir.reports.surveyVolume': 'Objem prieskumov podľa dátumu',
  'dir.reports.surveyVolumeDescription': 'Backend vracia počet odpovedí podľa dátumu; nejde o denné skóre. Nižšie sa vzorkuje posledných 100 odpovedí.',
  'dir.reports.surveyResponses': 'Odpovede na prieskum',
  'dir.reports.surveyVolumeAria': 'Objem odpovedí na prieskum CSAT podľa dátumu',
  'dir.reports.responsesByGroup': 'Odpovede podľa skupiny',
  'dir.reports.responsesByGroupDescription': 'Počet odpovedí na prieskum, nie miera spokojnosti skupiny',
  'dir.reports.responsesByAgent': 'Odpovede podľa agenta',
  'dir.reports.responsesByAgentDescription': 'Počet odpovedí na prieskum, nie miera spokojnosti agenta',
  'dir.reports.customerVoice': 'Hlas zákazníka',
  'dir.reports.latestSurveys': 'Najnovšie odpovede na prieskum',
  'dir.reports.boundedSample': 'Obmedzená vzorka · {count} z max. 100',
  'dir.reports.latestSurveysNote': 'Najnovšie odpovede vrátené API na vytváranie prehľadov. Táto tabuľka slúži na rýchle prečítanie, nie ako úplný export.',
  'dir.reports.noSurveys': 'Žiadne odpovede na prieskum',
  'dir.reports.noSurveysDescription': 'Odpovede CSAT sa tu zobrazia, keď zákazníci ohodnotia vyriešený tiket.',
  'dir.reports.rating': 'Hodnotenie',
  'dir.reports.comment': 'Komentár',
  'dir.reports.received': 'Prijaté',
  'dir.reports.ratingOutOf': '{rating} z 5',
  'dir.reports.noComment': 'Bez komentára',
  'dir.reports.rcaEyebrow': 'Analýza základnej príčiny',
  'dir.reports.rcaTitle': 'Prečo vznikajú tikety',
  'dir.reports.rcaDescription': 'Kategória a podkategória sú nezávislé agregácie zo štandardizovaných vlastných polí tiketu.',
  'dir.reports.rcaDimensionAria': 'Dimenzia RCA',
  'dir.reports.category': 'Kategória',
  'dir.reports.subcategory': 'Podkategória',
  'dir.reports.rcaEmpty': 'Pre toto obdobie neboli zaznamenané žiadne hodnoty základnej príčiny.',
  'dir.kb.articleLoadError': 'Článok sa nepodarilo načítať.',
  'dir.kb.articleNotFound': 'Článok nenájdený.',
  'dir.kb.retry': 'Skúsiť znova',
  'dir.kb.title': 'Znalostná databáza',
  'dir.kb.breadcrumb': 'Znalostná databáza',
  'dir.kb.description': 'Články: {articles}, priečinky: {folders}',
  'dir.kb.newArticle': 'Nový článok',
  'dir.kb.editArticle': 'Upraviť článok',
  'dir.kb.sectionsAria': 'Sekcie znalostnej databázy',
  'dir.kb.tabArticles': 'Články',
  'dir.kb.tabStructure': 'Kategórie a priečinky',
  'dir.kb.folderFilterAria': 'Filter priečinkov',
  'dir.kb.allArticles': 'Všetky články ({count})',
  'dir.kb.writeFirst': 'Napíšte svoj prvý článok',
  'dir.kb.writeFirstDescription': 'Pomocou Nový článok pridajte obsah do tohto priečinka.',
  'dir.kb.byAuthor': 'od {name}',
  'dir.kb.views': '{count} zobrazení',
  'dir.kb.published': 'Publikované',
  'dir.kb.draft': 'Koncept',
  'dir.kb.publish': 'Publikovať',
  'dir.kb.unpublish': 'Zrušiť publikovanie',
  'dir.kb.noFolders': 'V tejto kategórii nie sú žiadne priečinky',
  'dir.kb.noFoldersDescription': 'Pridajte priečinok a začnite zoskupovať články.',
  'dir.kb.articlesCount': 'Články: {count}',
  'dir.kb.fieldTitle': 'Názov',
  'dir.kb.folder': 'Priečinok',
  'dir.kb.selectFolder': 'Vyberte priečinok',
  'dir.kb.content': 'Obsah',
  'dir.kb.contentPlaceholder': 'Napíšte obsah článku...',
  'dir.kb.tags': 'Značky (oddelené čiarkou)',
  'dir.kb.attachments': 'Prílohy',
  'dir.kb.download': 'Stiahnuť',
  'dir.kb.downloadFile': 'Stiahnuť {name}',
  'dir.kb.remove': 'Odstrániť',
  'dir.kb.removeFile': 'Odstrániť {name}',
  'dir.kb.noAttachments': 'Zatiaľ žiadne prílohy.',
  'dir.kb.uploadAria': 'Nahrať prílohu',
  'dir.kb.uploading': 'Nahráva sa...',
  'dir.kb.addFile': 'Pridať súbor',
  'dir.kb.confirmDeleteTitle': 'Odstrániť článok?',
  'dir.kb.confirmDeleteDescription': 'Tento publikovaný alebo konceptový článok bude trvalo odstránený.',
  'dir.kb.confirmDeleteLabel': 'Odstrániť článok',
  'dir.kb.confirmRemoveTitle': 'Odstrániť prílohu?',
  'dir.kb.confirmRemoveDescription': 'Súbor bude z tohto článku trvalo odstránený.',
  'dir.kb.confirmRemoveLabel': 'Odstrániť prílohu',
  'dir.reports.rangeInvalid': 'Vyberte platné dátumy začiatku a konca.',
  'dir.reports.rangeOrder': 'Dátum konca musí byť rovnaký alebo neskorší ako dátum začiatku.',
  'dir.reports.rangeMax': 'Prehľady podporujú maximálny rozsah dátumov 90 dní.',

  'adm.active': 'Aktívne',
  'adm.auto.action.add_tag': 'pridať značku',
  'adm.auto.action.assign_agent': 'priradiť agenta',
  'adm.auto.action.assign_group': 'priradiť skupinu',
  'adm.auto.action.send_email': 'odoslať e-mail',
  'adm.auto.action.send_notification': 'odoslať oznámenie',
  'adm.auto.action.set_priority': 'nastaviť prioritu',
  'adm.auto.action.set_status': 'nastaviť stav',
  'adm.auto.actions': 'Akcie',
  'adm.auto.addAction': '+ Pridať akciu',
  'adm.auto.addCondition': '+ Pridať podmienku',
  'adm.auto.addRule': 'Pridať pravidlo',
  'adm.auto.colApplied': 'Použité akcie',
  'adm.auto.colDate': 'Dátum',
  'adm.auto.colMatched': 'Zhoda',
  'adm.auto.colSubject': 'Predmet',
  'adm.auto.colTicket': 'Tiket',
  'adm.auto.conditions': 'Podmienky',
  'adm.auto.confirmDesc': 'Toto pravidlo sa okamžite prestane vykonávať a nie je možné ho obnoviť.',
  'adm.auto.confirmLabel': 'Odstrániť pravidlo',
  'adm.auto.confirmTitle': 'Odstrániť pravidlo automatizácie?',
  'adm.auto.countMany': 'Pravidlá automatizácie: {count}',
  'adm.auto.countOne': '{count} pravidlo automatizácie',
  'adm.auto.create': 'Vytvoriť',
  'adm.auto.createFirst': 'Vytvorte svoje prvé pravidlo automatizácie',
  'adm.auto.createFirstDesc': 'Pomocou Pridať pravidlo môžete automaticky smerovať, prioritizovať alebo oznamovať.',
  'adm.auto.deleteFailed': 'Odstránenie zlyhalo',
  'adm.auto.description': 'Pravidlá sa vykonávajú postupne podľa poradia. Podmienky v rámci pravidla sú spojené operátorom AND.',
  'adm.auto.editRule': 'Upraviť pravidlo automatizácie',
  'adm.auto.execFailed': 'Vykonania sa nepodarilo načítať',
  'adm.auto.field.assigneeId': 'riešiteľ',
  'adm.auto.field.companyId': 'spoločnosť',
  'adm.auto.field.groupId': 'skupina',
  'adm.auto.field.priority': 'priorita',
  'adm.auto.field.requesterId': 'žiadateľ',
  'adm.auto.field.source': 'zdroj',
  'adm.auto.field.status': 'stav',
  'adm.auto.field.subject': 'predmet',
  'adm.auto.field.ticketTypeId': 'typ tiketu',
  'adm.auto.hits': 'Zásahy',
  'adm.auto.loadFailed': 'Pravidlá automatizácie sa nepodarilo načítať',
  'adm.auto.log': 'Záznam',
  'adm.auto.logTitle': 'Záznam vykonania — {name}',
  'adm.auto.moveDown': 'Posunúť nadol',
  'adm.auto.moveUp': 'Posunúť nahor',
  'adm.auto.newRule': 'Nové pravidlo automatizácie',
  'adm.auto.no': 'Nie',
  'adm.auto.noRuns': 'Zatiaľ nie sú zaznamenané žiadne vykonania',
  'adm.auto.noRunsDesc': 'Vykonania sa tu zobrazia, keď toto pravidlo prvýkrát zodpovedá nejakému tiketu.',
  'adm.auto.op.contains': 'obsahuje',
  'adm.auto.op.ends_with': 'končí na',
  'adm.auto.op.greater_than': 'väčšie ako',
  'adm.auto.op.in': 'je v',
  'adm.auto.op.is': 'je',
  'adm.auto.op.is_empty': 'je prázdne',
  'adm.auto.op.is_not': 'nie je',
  'adm.auto.op.is_not_empty': 'nie je prázdne',
  'adm.auto.op.less_than': 'menšie ako',
  'adm.auto.op.not_contains': 'neobsahuje',
  'adm.auto.op.not_in': 'nie je v',
  'adm.auto.op.starts_with': 'začína na',
  'adm.auto.reorderFailed': 'Zmena poradia zlyhala',
  'adm.auto.saveFailed': 'Uloženie zlyhalo',
  'adm.auto.stopProcessing': 'Zastaviť spracovanie nasledujúcich pravidiel',
  'adm.auto.title': 'Pravidlá automatizácie',
  'adm.auto.toggleFailed': 'Prepnutie zlyhalo',
  'adm.auto.trigger': 'Spúšťač *',
  'adm.auto.trigger.ticket_creation': 'Vytvorenie tiketu',
  'adm.auto.trigger.ticket_update': 'Aktualizácia tiketu',
  'adm.auto.trigger.time_trigger': 'Podľa času',
  'adm.auto.triggerCol': 'Spúšťač',
  'adm.auto.valuePlaceholder': 'Hodnota',
  'adm.auto.yes': 'Áno',
  'adm.close': 'Zavrieť',
  'adm.deleting': 'Odstraňuje sa...',
  'adm.description': 'Popis',
  'adm.descriptionLabel': 'Popis',
  'adm.edit': 'Upraviť',
  'adm.email.addChannel': 'Pridať kanál',
  'adm.email.addTitle': 'Pridať e-mailový kanál',
  'adm.email.colEmail': 'E-mail',
  'adm.email.colReplyTo': 'Odpovedať na',
  'adm.email.colSmtp': 'SMTP',
  'adm.email.confirmDesc': 'Tento kanál už nebude dostupný pre e-maily podpory.',
  'adm.email.confirmLabel': 'Odstrániť kanál',
  'adm.email.confirmTitle': 'Odstrániť e-mailový kanál?',
  'adm.email.countMany': 'E-mailové kanály: {count}',
  'adm.email.countOne': '{count} e-mailový kanál',
  'adm.email.create': 'Vytvoriť',
  'adm.email.createFirst': 'Pridajte svoj prvý e-mailový kanál',
  'adm.email.createFirstDesc': 'Pomocou Pridať kanál pripojte adresu podpory, aby odpovede prichádzali do tohto centra.',
  'adm.email.default': 'Predvolený',
  'adm.email.defaultChannel': 'Predvolený kanál',
  'adm.email.deleteFailed': 'Odstránenie zlyhalo',
  'adm.email.description': 'Spravujte prichádzajúce a odchádzajúce e-mailové adresy, konfiguráciu SMTP a nastavenia adresy pre odpovede.',
  'adm.email.editTitle': 'Upraviť e-mailový kanál',
  'adm.email.emailAddress': 'E-mailová adresa *',
  'adm.email.loadFailed': 'E-mailové konfigurácie sa nepodarilo načítať',
  'adm.email.outbound': 'Odchádzajúci SMTP',
  'adm.email.replyTo': 'Adresa pre odpovede',
  'adm.email.replyToPh': '(predvolene e-mailová adresa)',
  'adm.email.saveFailed': 'Uloženie zlyhalo',
  'adm.email.sesGlobal': 'SES (globálne)',
  'adm.email.smtpHost': 'Hostiteľ SMTP',
  'adm.email.smtpHostPh': 'napr. email-smtp.eu-central-1.amazonaws.com',
  'adm.email.smtpPassword': 'Heslo SMTP',
  'adm.email.smtpPort': 'Port SMTP',
  'adm.email.smtpUser': 'Používateľ SMTP',
  'adm.email.title': 'E-mailové kanály',
  'adm.groups.aboutBody': 'Členovia určujú, ktorí agenti predvolene vidia tikety tejto skupiny. Pracovný čas riadi časovanie SLA pre sem smerované tikety a kontakt pre eskaláciu dostane oznámenie okrem riešiteľa, keď tiket poruší svoje SLA.',
  'adm.groups.aboutTitle': 'O tejto skupine',
  'adm.groups.accountDefault': 'Predvolené pre účet',
  'adm.groups.activeAgentMany': 'Aktívni agenti: {count}',
  'adm.groups.activeAgentOne': '{count} aktívny agent',
  'adm.groups.activeAgents': 'Aktívni agenti',
  'adm.groups.addMember': 'Pridať člena',
  'adm.groups.assignment': 'Priradenie',
  'adm.groups.autoAssign': 'Automatické priradenie',
  'adm.groups.autoAssignNote': 'Priradenie tiketov je v tomto produkte vždy manuálne – neexistuje smerovanie round-robin ani podľa zaťaženia. Tento prepínač to nemení.',
  'adm.groups.businessHours': 'Pracovný čas',
  'adm.groups.colGroup': 'Skupina',
  'adm.groups.confirmDesc': 'Tikety a šablóny používajúce túto skupinu je potrebné najprv priradiť inam.',
  'adm.groups.confirmLabel': 'Odstrániť skupinu',
  'adm.groups.confirmTitle': 'Odstrániť „{name}“?',
  'adm.groups.createFirst': 'Vytvorte svoju prvú skupinu',
  'adm.groups.defaultHours': 'Predvolený čas',
  'adm.groups.editAria': 'Upraviť {name}',
  'adm.groups.editGroup': 'Upraviť skupinu',
  'adm.groups.escalateHelp': 'Pridá sa ako príjemca oznámenia, keď tiket v tejto skupine poruší svoje SLA.',
  'adm.groups.escalateTo': 'Eskalovať na',
  'adm.groups.escalatesTo': 'Eskaluje na',
  'adm.groups.escalatesToName': 'Eskaluje na {name}',
  'adm.groups.escalationBody': 'Keď tiket v tejto skupine poruší svoje SLA, kontakt pre eskaláciu sa pridá ako príjemca oznámenia spolu s riešiteľom a členmi skupiny.',
  'adm.groups.escalationTitle': 'Kontakt pre eskaláciu',
  'adm.groups.hoursHelp': 'Používa sa na výpočty SLA pre tikety v tejto skupine.',
  'adm.groups.manageAgents': 'Spravovať agentov',
  'adm.groups.manageHours': 'Spravovať pracovný čas',
  'adm.groups.manual': 'Manuálne',
  'adm.groups.manualBody': 'Priradenie je v tomto produkte manuálne – neexistuje automatické priradenie round-robin ani podľa zaťaženia. Prepínač „Automatické priradenie“ pri skupine len ovplyvňuje, či nové tikety v tejto skupine zostanú predvolene nepriradené alebo sa použije existujúce pravidlo smerovania; agenti si tikety stále preberajú a odovzdávajú sami.',
  'adm.groups.manualTitle': 'Manuálne priradenie',
  'adm.groups.memberMany': 'Členovia: {count}',
  'adm.groups.memberOne': '{count} člen',
  'adm.groups.members': 'Členovia',
  'adm.groups.newGroup': 'Nová skupina',
  'adm.groups.noEscalation': 'Žiadny kontakt pre eskaláciu',
  'adm.groups.noMatch': 'Tomuto vyhľadávaniu nezodpovedajú žiadne skupiny',
  'adm.groups.noMembers': 'Zatiaľ žiadni členovia',
  'adm.groups.noMembersDesc': 'Vyberte vyššie aktívneho agenta a zvoľte Pridať člena.',
  'adm.groups.remove': 'Odstrániť',
  'adm.groups.routing': 'Smerovanie',
  'adm.groups.routingMethod': 'Spôsob smerovania',
  'adm.groups.saved': 'Skupina bola uložená.',
  'adm.groups.searchAria': 'Hľadať skupiny',
  'adm.groups.searchPlaceholder': 'Hľadať podľa názvu',
  'adm.groups.selectActiveAgent': 'Vyberte aktívneho agenta',
  'adm.groups.showing': 'Zobrazuje sa {start}–{end} z {total}',
  'adm.groups.subtitle': 'Skupiny riadia smerovanie a viditeľnosť tiketov. Priraďte agentov ako členov a vyberte pre každú skupinu rozvrh pracovného času a kontakt pre eskaláciu.',
  'adm.groups.title': 'Skupiny',
  'adm.groups.tryDifferent': 'Skúste iný názov skupiny.',
  'adm.groups.unassigned': 'Nepriradené',
  'adm.groups.useNew': 'Pomocou Nová skupina smerujte tikety na množinu agentov.',
  'adm.groups.zero': '0 skupín',
  'adm.inactive': 'Neaktívne',
  'adm.jira.accepted': 'Pripojenie bolo prijaté',
  'adm.jira.accountEmail': 'E-mail účtu Jira',
  'adm.jira.accountEmailLabel': 'E-mail účtu',
  'adm.jira.activeConn': 'Aktívne pripojenie',
  'adm.jira.addConnection': 'Pridať pripojenie',
  'adm.jira.addTitle': 'Pridať pripojenie Jira',
  'adm.jira.added': 'Pripojenie Jira bolo pridané',
  'adm.jira.apiToken': 'Token API',
  'adm.jira.clearSecret': 'Vymazať uložený tajný kľúč webhooku',
  'adm.jira.confirmDesc': 'Tým sa odstráni uložené pripojenie a prepojenia tiketov. Problémy v Jira sa neodstránia.',
  'adm.jira.confirmLabel': 'Odstrániť pripojenie',
  'adm.jira.confirmTitle': 'Odstrániť {name}?',
  'adm.jira.connName': 'Názov pripojenia',
  'adm.jira.connNamePh': 'Engineering Jira',
  'adm.jira.connectedAs': 'Pripojené ako {name}',
  'adm.jira.connectionDesk': 'Správa pripojení',
  'adm.jira.default': 'Predvolené',
  'adm.jira.defaultConn': 'Predvolené pripojenie',
  'adm.jira.defaultIssueType': 'Predvolený typ problému',
  'adm.jira.defaultProjectKey': 'Predvolený kľúč projektu',
  'adm.jira.defaults': 'Predvolené hodnoty',
  'adm.jira.description': 'Pripojte lokality Jira patriace účtu, aby agenti mohli prepájať problémy a udržiavať stav tiketov synchronizovaný.',
  'adm.jira.editTitle': 'Upraviť pripojenie Jira',
  'adm.jira.footer': 'Vytvorte webhook v Jira s koncovým bodom zobrazeným vyššie, prihláste odber udalostí aktualizácie problému a použite rovnaký tajný kľúč webhooku, aký je nastavený tu.',
  'adm.jira.heading': 'Udržujte podporu a vývoj v rovnakej slučke',
  'adm.jira.intro': 'Prihlasovacie údaje sú na serveri uložené šifrované a na túto obrazovku sa nikdy nevracajú. Nastavte tajný kľúč webhooku, keď má Jira posielať zmeny stavu späť do SuzukiDesk.',
  'adm.jira.no': 'Nie',
  'adm.jira.noConns': 'Zatiaľ žiadne pripojenia Jira',
  'adm.jira.noConnsDesc': 'Pridajte pripojenie, aby boli akcie Jira dostupné v detaile tiketu.',
  'adm.jira.noProject': 'Žiadny projekt',
  'adm.jira.pasteToken': 'Vložte token',
  'adm.jira.requestFailed': 'Požiadavka na Jira zlyhala. Skúste to znova.',
  'adm.jira.savedToast': 'Pripojenie Jira bolo uložené',
  'adm.jira.secretConfigured': 'Tajný kľúč nastavený: {value}',
  'adm.jira.secretHint': 'Pri vytváraní webhooku v Jira použite rovnaký tajný kľúč.',
  'adm.jira.secretOptional': 'Voliteľné, 16+ znakov',
  'adm.jira.siteUrl': 'URL lokality Jira',
  'adm.jira.siteUrlHint': 'Neuvádzajte v URL prihlasovacie údaje.',
  'adm.jira.syncFromJira': 'Stav z Jira späť do tiketu',
  'adm.jira.syncSnapshot': 'Snímka prepojeného problému',
  'adm.jira.syncToJira': 'Stav tiketu do Jira',
  'adm.jira.testConnection': 'Otestovať pripojenie',
  'adm.jira.testFailed': 'Test pripojenia zlyhal',
  'adm.jira.title': 'Integrácia Jira',
  'adm.jira.tokenHintEdit': 'Ak chcete ponechať aktuálny token, nechajte prázdne.',
  'adm.jira.tokenHintNew': 'Uložené šifrovane; už sa nezobrazí.',
  'adm.jira.tokenMissing': 'Token API chýba',
  'adm.jira.tokenStored': 'Token API je uložený',
  'adm.jira.unchanged': '(ak je prázdne, nezmení sa)',
  'adm.jira.verified': 'Pripojenie Jira bolo overené',
  'adm.jira.webhookEndpoint': 'Koncový bod webhooku Jira',
  'adm.jira.webhookSecret': 'Tajný kľúč webhooku',
  'adm.jira.whatSyncs': 'Čo sa synchronizuje',
  'adm.jira.yes': 'Áno',
  'adm.nameRequired': 'Meno *',
  'adm.nextPage': 'Ďalšia strana',
  'adm.notif.aud.all': 'Spoločné',
  'adm.notif.aud.customer': 'Zákazník',
  'adm.notif.aud.internal': 'Interné',
  'adm.notif.audEmail': 'E-mail: {audience}',
  'adm.notif.body': 'Text',
  'adm.notif.description': 'Prispôsobte oznámenia pre každé publikum bez presmerovania zákazníkov do interného pracovného priestoru.',
  'adm.notif.discardDesc': 'Neuložené zmeny tejto šablóny oznámenia sa stratia, ak prepnete šablónu.',
  'adm.notif.discardLabel': 'Zahodiť zmeny',
  'adm.notif.discardTitle': 'Zahodiť neuložené zmeny?',
  'adm.notif.discarded': 'Neuložené zmeny boli zahodené.',
  'adm.notif.event.automation_notification': 'Oznámenie automatizácie',
  'adm.notif.event.group_member_added': 'Pridanie do skupiny',
  'adm.notif.event.mention': 'Zmienenie',
  'adm.notif.event.pending_input': 'Čaká sa na vstup',
  'adm.notif.event.sla_breach': 'Porušenie SLA',
  'adm.notif.event.sla_escalation': 'Eskalácia SLA',
  'adm.notif.event.sla_warning': 'Upozornenie SLA',
  'adm.notif.event.ticket_assigned': 'Tiket priradený',
  'adm.notif.event.ticket_created': 'Tiket vytvorený',
  'adm.notif.event.ticket_first_response': 'Prvá odpoveď',
  'adm.notif.event.ticket_group_assigned': 'Tiket priradený skupine',
  'adm.notif.event.ticket_note': 'Súkromná poznámka',
  'adm.notif.event.ticket_public_note': 'Verejná poznámka',
  'adm.notif.event.ticket_reply': 'Odpoveď na tiket',
  'adm.notif.event.ticket_resolved': 'Tiket vyriešený',
  'adm.notif.events': 'Udalosti',
  'adm.notif.eventsHelp': 'Vyberte udalosť a publikum príjemcov.',
  'adm.notif.insertVar': 'Vložiť {variable}',
  'adm.notif.linkNoteAgent': 'Premenná odkazu podľa publika {variable} otvorí v tomto e-maile pracovný priestor agenta.',
  'adm.notif.linkNoteCustomer': 'Premenná odkazu podľa publika {variable} otvorí v tomto e-maile zákaznícky portál.',
  'adm.notif.off': 'vypnuté',
  'adm.notif.preview': 'Náhľad',
  'adm.notif.previewNotice': 'Náhľad je vykreslený s ukážkovými údajmi.',
  'adm.notif.rendering': 'Vykresľuje sa…',
  'adm.notif.route.all': 'Používa odkaz na tiket podľa príjemcu pre cieľové publikum doručenia.',
  'adm.notif.route.customer': 'Hlavná akcia otvorí tiket v zákazníckom portáli.',
  'adm.notif.route.internal': 'Hlavná akcia otvorí tiket v pracovnom priestore agenta.',
  'adm.notif.sampleOnlyAgent': 'Iba ukážkové údaje — hlavná akcia smeruje do pracovného priestoru agenta.',
  'adm.notif.sampleOnlyCustomer': 'Iba ukážkové údaje — hlavná akcia smeruje do zákazníckeho portálu.',
  'adm.notif.saveChanges': 'Uložiť zmeny',
  'adm.notif.saved': 'Šablóna bola uložená.',
  'adm.notif.savedBtn': 'Uložené',
  'adm.notif.selectEvent': 'Vyberte udalosť na úpravu jej šablóny',
  'adm.notif.selectEventDesc': 'Vyberte vľavo udalosť oznámenia, aby ste mohli zmeniť jej predmet a text.',
  'adm.notif.sendTest': 'Odoslať testovací e-mail',
  'adm.notif.sending': 'Odosiela sa…',
  'adm.notif.subject': 'Predmet',
  'adm.notif.testQueued': 'Testovací e-mail bol zaradený na odoslanie na {email}.',
  'adm.notif.title': 'Šablóny oznámení',
  'adm.notif.urlVarTitle': 'Premenná odkazu podľa publika',
  'adm.notif.useTemplate': 'Použiť túto šablónu pre toto publikum',
  'adm.notif.useTemplateHelp': 'Po vypnutí sa použije bezpečné záložné oznámenie.',
  'adm.notif.variables': 'Premenné',
  'adm.notif.variablesHelp': 'Kliknutím pripojíte na koniec textu správy',
  'adm.pagination': 'Stránkovanie',
  'adm.perm.cap.admin.label': 'Prístup do administračnej konzoly',
  'adm.perm.cap.assign.label': 'Priradiť tiket',
  'adm.perm.cap.close.label': 'Zavrieť tiket',
  'adm.perm.cap.conversation_delete.label': 'Odstrániť odoslanú odpoveď alebo poznámku',
  'adm.perm.cap.conversation_edit.label': 'Upraviť odoslanú odpoveď alebo poznámku',
  'adm.perm.cap.create.label': 'Vytvoriť tiket',
  'adm.perm.cap.delete.label': 'Odstrániť tiket',
  'adm.perm.cap.edit.label': 'Upraviť vlastnosti tiketu',
  'adm.perm.cap.export.label': 'Exportovať tikety',
  'adm.perm.cap.field_admin.label': 'Polia tiketu',
  'adm.perm.cap.form_admin.label': 'Formuláre tiketov',
  'adm.perm.cap.forward.label': 'Preposlať tiket',
  'adm.perm.cap.jira_link.label': 'Prepájať a spravovať problémy v Jira',
  'adm.perm.cap.kb.label': 'Prístup k znalostnej databáze',
  'adm.perm.cap.manage_agents.label': 'Agenti',
  'adm.perm.cap.manage_api_keys.label': 'Kľúče API',
  'adm.perm.cap.manage_automations.label': 'Automatizácie',
  'adm.perm.cap.manage_canned_responses.label': 'Uložené odpovede',
  'adm.perm.cap.manage_email_config.label': 'E-mail',
  'adm.perm.cap.manage_groups.label': 'Skupiny',
  'adm.perm.cap.manage_jira.label': 'Integrácia Jira',
  'adm.perm.cap.manage_kb.label': 'Znalostná databáza',
  'adm.perm.cap.manage_notification_templates.label': 'Šablóny oznámení',
  'adm.perm.cap.manage_roles.label': 'Roly',
  'adm.perm.cap.manage_tags.label': 'Značky',
  'adm.perm.cap.note.label': 'Pridávať alebo upravovať súkromné poznámky',
  'adm.perm.cap.reassign.label': 'Znovu priradiť tiket, ktorý už vlastní niekto iný',
  'adm.perm.cap.reopen.label': 'Znovu otvoriť vyriešený alebo zatvorený tiket',
  'adm.perm.cap.reply.label': 'Verejne odpovedať zákazníkovi',
  'adm.perm.cap.report_access.label': 'Zobraziť prehľady a dashboardy',
  'adm.perm.cap.reports.label': 'Prístup k modulu prehľadov',
  'adm.perm.cap.resolve.label': 'Vyriešiť tiket',
  'adm.perm.cap.settings_admin.label': 'Otvoriť sekciu Nastavenia (potrebné na zobrazenie položky Nastavenia v navigácii a jej úvodnej stránky; prístup k jednotlivým stránkam nižšie sa stále riadi samostatne)',
  'adm.perm.cap.sla_admin.label': 'Pravidlá SLA a pracovný čas',
  'adm.perm.cap.sla_edit.desc': 'Oddelené od nižšie uvedeného oprávnenia Nastavenia > Pravidlá SLA — týka sa iba úpravy termínov pri jednotlivom tikete.',
  'adm.perm.cap.sla_edit.label': 'Manuálne prepísať termíny SLA tiketu',
  'adm.perm.cap.tag.label': 'Spravovať značky tiketov',
  'adm.perm.cap.thread_start.label': 'Začať súkromné vlákno pri zázname konverzácie',
  'adm.perm.cap.tickets.label': 'Prístup k pracovnému priestoru tiketov',
  'adm.perm.cap.view.label': 'Zobraziť tikety v rozsahu',
  'adm.perm.cat.administration.desc': 'Prístup do administračnej konzoly a jej konfiguračných obrazoviek.',
  'adm.perm.cat.administration.label': 'Administrácia',
  'adm.perm.cat.knowledge.desc': 'Čítanie a používanie obsahu znalostnej databázy pri práci na tikete.',
  'adm.perm.cat.knowledge.label': 'Znalostná databáza',
  'adm.perm.cat.reporting.desc': 'Prevádzkové prehľady a dashboardy.',
  'adm.perm.cat.reporting.label': 'Prehľady',
  'adm.perm.cat.settings-pages.desc': 'Udeľte prístup ku každej obrazovke Nastavení samostatne. Nič nie je viditeľné, kým to tu nie je výslovne zaškrtnuté.',
  'adm.perm.cat.settings-pages.label': 'Stránky nastavení',
  'adm.perm.cat.tickets.desc': 'Čo môže agent robiť v pracovnom priestore tiketov.',
  'adm.perm.cat.tickets.label': 'Tikety',
  'adm.previousPage': 'Predchádzajúca strana',
  'adm.refresh': 'Obnoviť',
  'adm.roleType.administrator': 'Administrátor',
  'adm.roleType.agent': 'Agent',
  'adm.roleType.collaborator': 'Spolupracovník',
  'adm.roleType.customer': 'Zákazník',
  'adm.roleType.super_admin': 'Superadministrátor',
  'adm.roleType.supervisor': 'Supervízor',
  'adm.roles.activeHelp': 'Aktívna – neaktívne roly nie je možné priradiť agentom',
  'adm.roles.agentCan': 'Agent môže',
  'adm.roles.agentType': 'Typ agenta',
  'adm.roles.agentsAssignedNote': 'Agentom sa táto rola priraďuje na obrazovke Agenti.',
  'adm.roles.agentsCount': 'Agenti: {count}',
  'adm.roles.agentsLabel': 'Agenti',
  'adm.roles.agentsManage': 'Agenti: {count} – Spravovať',
  'adm.roles.builtIn': '(Vstavaná)',
  'adm.roles.builtInNote': 'Toto je vstavaná rola. Dá sa premenovať a deaktivovať, ale nie odstrániť.',
  'adm.roles.builtInTitle': 'Vstavaná rola: dá sa upraviť a deaktivovať, ale nie odstrániť',
  'adm.roles.categoriesAria': 'Kategórie oprávnení',
  'adm.roles.confirmDesc': 'Agentom priradeným k tejto role treba pred jej odstránením priradiť inú rolu.',
  'adm.roles.confirmLabel': 'Odstrániť rolu',
  'adm.roles.createFirst': 'Vytvorte svoju prvú rolu',
  'adm.roles.createFirstDesc': 'Pomocou Nová rola definujte schopnosti, ktoré majú agenti získať.',
  'adm.roles.editRole': 'Upraviť rolu',
  'adm.roles.granted': 'Udelené: {count}',
  'adm.roles.heading': 'Roly agentov',
  'adm.roles.inactive': 'Neaktívna',
  'adm.roles.newRole': 'Nová rola',
  'adm.roles.noAgent': 'Žiadny agent',
  'adm.roles.notEnforced': '(zatiaľ sa nevynucuje)',
  'adm.roles.notEnforcedTitle': 'Uložené pri role, ale za behu sa zatiaľ nikde nekontroluje',
  'adm.roles.permissions': 'Oprávnenia',
  'adm.roles.saved': 'Rola bola uložená.',
  'adm.roles.scopeBody': 'Schopnosti sa kombinujú s rozsahom na úrovni riadkov (všetky / skupina / priradené / vlastné), takže agent vždy koná iba na tiketoch, ktoré už vidí.',
  'adm.roles.scopeTitle': 'Rozsah sa stále uplatňuje',
  'adm.roles.scrollTo': 'Prejsť na',
  'adm.roles.status': 'Stav',
  'adm.roles.subtitle': 'Poskytujte a obmedzujte podrobné úrovne prístupu a oprávnení pre agentov.',
  'adm.roles.title': 'Roly',
  'adm.roles.typeLocked': 'Typ agenta nie je možné zmeniť po uložení roly.',
  'adm.roles.understandingBody1': 'Roly určujú, čo môže agent robiť. Vytvorte rolu, zaškrtnite schopnosti, ktoré má udeliť, a potom ju priraďte agentom na obrazovke Agenti.',
  'adm.roles.understandingBody2': 'Vstavané roly sa dajú premenovať a deaktivovať, ale nikdy odstrániť. Rolu, ktorá má stále priradených agentov, tiež nie je možné odstrániť, preto tých agentov najprv presuňte.',
  'adm.roles.understandingTitle': 'Pochopenie rolí',
  'adm.saveChanges': 'Uložiť zmeny',
  'adm.settings.add': 'Pridať {name}',
  'adm.settings.back': 'Späť na nastavenia',
  'adm.settings.cannedDesc': 'Odpovede účtu dostupné pre vás pri práci na tikete.',
  'adm.settings.cannedEmpty': 'Zatiaľ žiadne uložené odpovede',
  'adm.settings.cannedEmptyDesc': 'Požiadajte administrátora, aby pridal zdieľané odpovede, ktoré váš tím môže použiť pri tikete.',
  'adm.settings.cannedTitle': 'Uložené odpovede',
  'adm.settings.col.autoAssign': 'Automatické priradenie',
  'adm.settings.col.color': 'Farba',
  'adm.settings.col.content': 'Obsah',
  'adm.settings.col.createdAt': 'Vytvorené',
  'adm.settings.col.description': 'Popis',
  'adm.settings.col.email': 'E-mail',
  'adm.settings.col.expiresAt': 'Platné do',
  'adm.settings.col.fieldType': 'Typ poľa',
  'adm.settings.col.firstName': 'Meno',
  'adm.settings.col.folderId': 'ID priečinka',
  'adm.settings.col.hitCount': 'Počet zásahov',
  'adm.settings.col.holidays': 'Sviatky',
  'adm.settings.col.host': 'Hostiteľ',
  'adm.settings.col.hours': 'Hodiny',
  'adm.settings.col.id': 'ID',
  'adm.settings.col.isActive': 'Aktívne',
  'adm.settings.col.isBuiltIn': 'Vstavané',
  'adm.settings.col.isDefault': 'Predvolené',
  'adm.settings.col.isRequired': 'Povinné',
  'adm.settings.col.isShared': 'Zdieľané',
  'adm.settings.col.isSystem': 'Systémové',
  'adm.settings.col.key': 'Kľúč',
  'adm.settings.col.label': 'Označenie',
  'adm.settings.col.language': 'Jazyk',
  'adm.settings.col.lastName': 'Priezvisko',
  'adm.settings.col.lastUsedAt': 'Naposledy použité',
  'adm.settings.col.name': 'Meno',
  'adm.settings.col.options': 'Možnosti',
  'adm.settings.col.phone': 'Telefón',
  'adm.settings.col.port': 'Port',
  'adm.settings.col.position': 'Poradie',
  'adm.settings.col.prefix': 'Predpona',
  'adm.settings.col.priority': 'Priorita',
  'adm.settings.col.required': 'Povinné',
  'adm.settings.col.role': 'Rola',
  'adm.settings.col.roleId': 'ID roly',
  'adm.settings.col.scopes': 'Rozsahy',
  'adm.settings.col.slug': 'Slug',
  'adm.settings.col.status': 'Stav',
  'adm.settings.col.stopProcessing': 'Zastaviť spracovanie',
  'adm.settings.col.timezone': 'Časové pásmo',
  'adm.settings.col.title': 'Názov',
  'adm.settings.col.trigger': 'Spúšťač',
  'adm.settings.col.type': 'Typ',
  'adm.settings.col.updatedAt': 'Aktualizované',
  'adm.settings.col.usageCount': 'Počet použití',
  'adm.settings.col.username': 'Používateľské meno',
  'adm.settings.confirmDesc': 'Túto akciu nie je možné vrátiť späť.',
  'adm.settings.confirmTitle': 'Odstrániť {name}?',
  'adm.settings.count': '{count} {title}',
  'adm.settings.create': 'Vytvoriť',
  'adm.settings.empty': 'Zatiaľ žiadne: {title}',
  'adm.settings.emptyAdd': 'Pomocou formulára vyššie pridajte svoje prvé: {name}.',
  'adm.settings.emptyOther': 'Záznamy sa tu zobrazia po ich nakonfigurovaní.',
  'adm.settings.homeDesc': 'Nakonfigurujte používateľov, pracovné postupy tiketov, úrovne služieb a integrácie.',
  'adm.settings.manage': 'Spravovať: {title}.',
  'adm.settings.noPages': 'Nie sú dostupné žiadne stránky nastavení',
  'adm.settings.noPagesDesc': 'Požiadajte superadministrátora, aby vám udelil prístup k potrebným stránkam nastavení.',
  'adm.settings.notFound': 'Stránka nastavení nenájdená',
  'adm.settings.notFoundDesc': 'Vyberte oblasť nastavení a pokračujte.',
  'adm.settings.res.agents.field.email': 'E-mail',
  'adm.settings.res.agents.field.firstName': 'Meno',
  'adm.settings.res.agents.field.lastName': 'Priezvisko',
  'adm.settings.res.agents.field.password': 'Dočasné heslo',
  'adm.settings.res.agents.field.roleId': 'ID roly',
  'adm.settings.res.agents.one': 'agenta',
  'adm.settings.res.agents.title': 'Agenti',
  'adm.settings.res.api-keys.field.name': 'Názov kľúča',
  'adm.settings.res.api-keys.one': 'kľúč API',
  'adm.settings.res.api-keys.title': 'Kľúče API',
  'adm.settings.res.automations.field.description': 'Popis',
  'adm.settings.res.automations.field.name': 'Meno',
  'adm.settings.res.automations.one': 'automatizáciu',
  'adm.settings.res.automations.title': 'Automatizácie',
  'adm.settings.res.business-hours.field.name': 'Meno',
  'adm.settings.res.business-hours.field.timezone': 'Časové pásmo',
  'adm.settings.res.business-hours.one': 'záznam pracovného času',
  'adm.settings.res.business-hours.title': 'Pracovný čas',
  'adm.settings.res.canned-responses.field.content': 'Obsah odpovede',
  'adm.settings.res.canned-responses.field.title': 'Názov',
  'adm.settings.res.canned-responses.one': 'uloženú odpoveď',
  'adm.settings.res.canned-responses.title': 'Uložené odpovede',
  'adm.settings.res.email.field.host': 'Hostiteľ SMTP',
  'adm.settings.res.email.field.name': 'Meno',
  'adm.settings.res.email.field.port': 'Port SMTP',
  'adm.settings.res.email.field.username': 'Používateľské meno',
  'adm.settings.res.email.one': 'e-mailovú konfiguráciu',
  'adm.settings.res.email.title': 'Konfigurácia e-mailu',
  'adm.settings.res.fields.one': 'pole tiketu',
  'adm.settings.res.fields.title': 'Polia tiketu',
  'adm.settings.res.forms.field.label': 'Zobrazený názov',
  'adm.settings.res.forms.field.name': 'Názov poľa',
  'adm.settings.res.forms.field.type': 'Typ poľa',
  'adm.settings.res.forms.one': 'formulár alebo vlastné pole',
  'adm.settings.res.forms.title': 'Formuláre a vlastné polia',
  'adm.settings.res.groups.field.description': 'Popis',
  'adm.settings.res.groups.field.name': 'Meno',
  'adm.settings.res.groups.one': 'skupinu',
  'adm.settings.res.groups.title': 'Skupiny',
  'adm.settings.res.jira.one': 'integráciu Jira',
  'adm.settings.res.jira.title': 'Integrácia Jira',
  'adm.settings.res.kb.field.content': 'Obsah článku',
  'adm.settings.res.kb.field.folderId': 'ID priečinka',
  'adm.settings.res.kb.field.title': 'Názov článku',
  'adm.settings.res.kb.one': 'článok znalostnej databázy',
  'adm.settings.res.kb.title': 'Správa znalostnej databázy',
  'adm.settings.res.notification-templates.one': 'šablónu oznámenia',
  'adm.settings.res.notification-templates.title': 'Šablóny oznámení',
  'adm.settings.res.roles.field.description': 'Popis',
  'adm.settings.res.roles.field.name': 'Meno',
  'adm.settings.res.roles.field.type': 'Typ roly',
  'adm.settings.res.roles.one': 'rolu',
  'adm.settings.res.roles.title': 'Roly',
  'adm.settings.res.sla.field.description': 'Popis',
  'adm.settings.res.sla.field.name': 'Meno',
  'adm.settings.res.sla.one': 'pravidlo SLA',
  'adm.settings.res.sla.title': 'Pravidlá SLA',
  'adm.settings.res.tags.field.name': 'Meno',
  'adm.settings.res.tags.one': 'značku',
  'adm.settings.res.tags.title': 'Značky',
  'adm.settings.title': 'Nastavenia',
  'adm.status': 'Stav',

  'sla.edit': 'Upraviť',
  'sla.active': 'Aktívne',
  'sla.inactive': 'Neaktívne',
  'sla.default': 'Predvolené',
  'sla.yes': 'Áno',
  'sla.no': 'Nie',
  'sla.description': 'Popis',
  'sla.status': 'Stav',
  'sla.notConfigured': 'Nenakonfigurované',
  'sla.minutesValue': '{value} min',
  'sla.invalidServerValue': 'Neplatná hodnota zo servera',
  'sla.statusSemantics.title': 'Sémantika stavov tiketu',
  'sla.statusSemantics.description': 'Každý aktívny stav má explicitnú zmluvu SLA. Stav, ktorý pozastavuje SLA, a stav, ktorý SLA zastavuje, sa navzájom vylučujú.',
  'sla.statusSemantics.conflict': 'Stav nemôže súčasne pozastaviť SLA aj zastaviť SLA.',
  'sla.statusSemantics.emptyTitle': 'Žiadne definície stavov',
  'sla.statusSemantics.emptyDescription': 'Definície stavov sa tu zobrazia po ich nastavení pre tento účet.',
  'sla.statusSemantics.colPauses': 'Pozastavuje SLA',
  'sla.statusSemantics.colStops': 'Zastavuje SLA',
  'sla.statusSemantics.pausesAria': '{label} pozastavuje SLA',
  'sla.statusSemantics.stopsAria': '{label} zastavuje SLA',
  'sla.preview.title': 'Náhľad tiketu len na čítanie',
  'sla.preview.description': 'Spustite rovnaký vyhodnocovač v rozsahu účtu, aký používajú živé cykly SLA. Tento náhľad nikdy nezapisuje pravidlo ani tiket.',
  'sla.preview.priority': 'Priorita',
  'sla.preview.group': 'Skupina',
  'sla.preview.anyGroup': 'Ktorákoľvek skupina',
  'sla.preview.company': 'Spoločnosť',
  'sla.preview.anyCompany': 'Ktorákoľvek spoločnosť',
  'sla.preview.source': 'Zdroj',
  'sla.preview.anySource': 'Ktorýkoľvek zdroj',
  'sla.preview.ticketType': 'Typ tiketu',
  'sla.preview.anyTicketType': 'Ktorýkoľvek typ tiketu',
  'sla.preview.representativeStart': 'Reprezentatívny začiatok',
  'sla.preview.calculating': 'Počíta sa…',
  'sla.preview.run': 'Spustiť náhľad',
  'sla.preview.configAttention': 'Konfigurácia vyžaduje pozornosť',
  'sla.preview.selectedPolicy': 'Vybrané pravidlo',
  'sla.preview.noPolicy': 'Žiadne pravidlo',
  'sla.preview.evaluationOrder': 'Poradie vyhodnocovania',
  'sla.preview.firstMatching': 'Prvé zodpovedajúce pravidlo',
  'sla.preview.calculationMode': 'Režim výpočtu',
  'sla.preview.modeBusinessHours': 'Pracovný čas',
  'sla.preview.modeBusinessHoursNamed': 'Pracovný čas · {name}',
  'sla.preview.mode247': 'Uplynutý čas 24/7',
  'sla.preview.modeNone': 'Nevypočítané',
  'sla.preview.thresholds': 'Nezávislé prahy',
  'sla.preview.colMetric': 'Metrika',
  'sla.preview.colTarget': 'Cieľ',
  'sla.preview.colWarning': 'Upozornenie',
  'sla.preview.colDue': 'Termín / porušenie',
  'sla.preview.colEscalation': 'Eskalácia',
  'sla.preview.colState': 'Stav',
  'sla.preview.metricFirstResponse': 'Prvá odpoveď',
  'sla.preview.metricResolution': 'Vyriešenie',
  'sla.preview.trace': 'Stopa vyhodnotenia pravidiel',
  'sla.preview.selected': 'Vybrané',
  'sla.preview.matchedAfterSelection': 'Zhoda po výbere',
  'sla.preview.skipped': 'Preskočené',
  'sla.preview.showTrace': 'Zobraziť stopu výpočtu',
  'sla.state.not_configured': 'nenakonfigurované',
  'sla.state.running': 'beží',
  'sla.state.paused': 'pozastavené',
  'sla.state.warning': 'upozornenie',
  'sla.state.breached': 'porušené',
  'sla.state.met': 'splnené',
  'sla.state.escalated': 'eskalované',
  'sla.state.pending': 'čaká',
  'sla.state.stopped': 'zastavené',
  'sla.state.on_track': 'v poriadku',
  'sla.state.at_risk': 'ohrozené',
  'sla.list.subtitle': 'Nastavte ciele prvej odpovede a vyriešenia pre každú prioritu. Pravidlá sa vyhodnocujú zhora nadol – vyhráva prvé, ktorého podmienky tiketu zodpovedajú.',
  'sla.list.newPolicy': 'Nové pravidlo',
  'sla.list.emptyTitle': 'Vytvorte svoje prvé pravidlo SLA',
  'sla.list.emptyDescription': 'Pomocou Nové pravidlo nastavte ciele prvej odpovede a vyriešenia pre každú prioritu.',
  'sla.list.moveUp': 'Posunúť nahor',
  'sla.list.moveDown': 'Posunúť nadol',
  'sla.list.frShort': 'PO: {value}',
  'sla.list.resolveShort': 'Vyriešenie: {value}',
  'sla.list.escalateShort': 'Eskalácia: +{value}',
  'sla.list.deactivate': 'Deaktivovať',
  'sla.list.activate': 'Aktivovať',
  'sla.list.setDefault': 'Nastaviť ako predvolené',
  'sla.list.duplicate': 'Duplikovať',
  'sla.list.deleteTitle': 'Odstrániť „{name}“?',
  'sla.list.deleteDescription': 'Tikety priradené k tomuto pravidlu budú používať ďalšie dostupné pravidlo SLA.',
  'sla.list.deleteConfirm': 'Odstrániť pravidlo',
  'sla.conditions.groups': 'skupiny: {count}',
  'sla.conditions.companies': 'spoločnosti: {count}',
  'sla.conditions.sources': 'zdroje: {list}',
  'sla.conditions.ticketTypes': 'typy tiketov: {count}',
  'sla.conditions.anyOf': 'ktorákoľvek z',
  'sla.conditions.allOf': 'všetky z',
  'sla.conditions.summary': 'Podmienky ({mode}): {parts}',
  'sla.edit.newTitle': 'Nové pravidlo SLA',
  'sla.edit.editTitle': 'Upraviť pravidlo SLA',
  'sla.edit.saved': 'Pravidlo SLA bolo uložené.',
  'sla.edit.name': 'Meno',
  'sla.edit.appliesToPriority': 'Platí pre prioritu',
  'sla.edit.evaluationOrder': 'Poradie vyhodnocovania',
  'sla.edit.evaluationOrderHint': 'Nižšie pozície sa pre tento účet vyhodnocujú ako prvé.',
  'sla.edit.defaultPolicy': 'Predvolené pravidlo',
  'sla.edit.useAsDefault': 'Použiť ako predvolené, keď nezodpovedá žiadne iné pravidlo',
  'sla.edit.targets': 'Ciele SLA',
  'sla.edit.firstResponse': 'Prvá odpoveď',
  'sla.edit.resolution': 'Vyriešenie',
  'sla.edit.autoAt75': 'Automaticky pri 75 %',
  'sla.edit.enabledAfter': 'Zapnuté po {value}',
  'sla.edit.clearEscalation': 'Explicitne zrušiť cieľ eskalácie',
  'sla.edit.clearEscalationHint': 'Odošle null; ak ponecháte nezaškrtnuté, pole sa vynechá a uložená hodnota sa zachová.',
  'sla.edit.firstResponseMinutes': 'Prvá odpoveď (minúty)',
  'sla.edit.resolutionMinutes': 'Vyriešenie (minúty)',
  'sla.edit.escalateAfter': 'Eskalovať po (minút po termíne vyriešenia)',
  'sla.edit.notSet': 'Nenastavené',
  'sla.edit.remindersNote': 'Pripomienky sa automaticky spustia pri 75 % okien prvej odpovede a vyriešenia. Eskalácia upozorní agenta pre eskaláciu skupiny tiketu (nastavuje sa v skupine), keď je cieľ vyriešenia zmeškaný o nakonfigurovaný počet minút.',
  'sla.edit.conditions': 'Podmienky',
  'sla.edit.conditionsHint': 'Ak skupinu nezaškrtnete, zodpovedajú všetky hodnoty',
  'sla.edit.matchMode': 'Režim zhody:',
  'sla.edit.matchAll': 'Musia sa zhodovať VŠETKY podmienky',
  'sla.edit.matchAny': 'Musí sa zhodovať ĽUBOVOĽNÁ podmienka',
  'sla.edit.groups': 'Skupiny',
  'sla.edit.companies': 'Spoločnosti',
  'sla.edit.sources': 'Zdroje',
  'sla.edit.ticketTypes': 'Typy tiketov',
  'sla.bh.subtitle': 'Definujte týždenný rozvrh a kalendár sviatkov, ktoré pravidlá SLA používajú na výpočet termínov.',
  'sla.bh.newCalendar': 'Nový kalendár',
  'sla.bh.emptyTitle': 'Vytvorte svoj prvý kalendár pracovného času',
  'sla.bh.emptyDescription': 'Pomocou Nový kalendár definujte týždenný rozvrh, podľa ktorého pravidlá SLA počítajú.',
  'sla.bh.accountDefault': 'Predvolené pre účet',
  'sla.bh.closedEveryDay': 'Zatvorené každý deň',
  'sla.bh.openEveryDay': 'Otvorené každý deň',
  'sla.bh.openDaysOne': 'Otvorené 1 deň v týždni',
  'sla.bh.openDaysMany': 'Otvorené {count} dní v týždni',
  'sla.bh.holidayOne': '1 sviatok',
  'sla.bh.holidayMany': 'Sviatky: {count}',
  'sla.bh.deleteTitle': 'Odstrániť „{name}“?',
  'sla.bh.deleteDescription': 'Pravidlá SLA a skupiny používajúce tento rozvrh sa vrátia na predvolenú hodnotu účtu.',
  'sla.bh.deleteConfirm': 'Odstrániť rozvrh',
  'sla.bh.newTitle': 'Nový kalendár pracovného času',
  'sla.bh.editTitle': 'Upraviť pracovný čas',
  'sla.bh.saved': 'Pracovný čas bol uložený.',
  'sla.bh.timezone': 'Časové pásmo',
  'sla.bh.defaultCalendar': 'Predvolený kalendár',
  'sla.bh.useAsDefault': 'Použiť pre pravidlá SLA a skupiny, ktoré neurčujú vlastný kalendár',
  'sla.bh.weeklySchedule': 'Týždenný rozvrh',
  'sla.bh.colDay': 'Deň',
  'sla.bh.colOpen': 'Otvorené',
  'sla.bh.colStart': 'Začiatok',
  'sla.bh.colEnd': 'Koniec',
  'sla.bh.dayOpenAria': '{day} otvorené',
  'sla.bh.dayStartAria': '{day} čas začiatku',
  'sla.bh.dayEndAria': '{day} čas konca',
  'sla.bh.holidayCalendar': 'Kalendár sviatkov',
  'sla.bh.saveFirst': 'Najprv uložte tento kalendár, potom pridajte sviatky.',
  'sla.bh.holidayName': 'Názov sviatku',
  'sla.bh.date': 'Dátum',
  'sla.bh.addHoliday': 'Pridať sviatok',
  'sla.bh.noHolidays': 'Zatiaľ žiadne sviatky',
  'sla.bh.noHolidaysHint': 'Pridajte vyššie sviatok s dátumom, aby bol vylúčený z výpočtov SLA.',
  'sla.bh.remove': 'Odstrániť',
  'sla.day.monday': 'Pondelok',
  'sla.day.tuesday': 'Utorok',
  'sla.day.wednesday': 'Streda',
  'sla.day.thursday': 'Štvrtok',
  'sla.day.friday': 'Piatok',
  'sla.day.saturday': 'Sobota',
  'sla.day.sunday': 'Nedeľa',

  'set.ftype.single_line_text': 'Jednoriadkový text',
  'set.ftype.multi_line_text': 'Viacriadkový text',
  'set.ftype.dropdown': 'Rozbaľovací zoznam',
  'set.ftype.checkbox': 'Začiarkavacie políčko',
  'set.ftype.radio': 'Prepínač',
  'set.ftype.multiselect': 'Viacnásobný výber',
  'set.ftype.lookup': 'Vzťah vyhľadávania',
  'set.ftype.dependent': 'Závislé pole',
  'set.ftype.date': 'Dátum',
  'set.ftype.number': 'Číslo',
  'set.ftype.decimal': 'Desatinné číslo',
  'set.ftype.desc.lookup': 'Vyberte záznam zo systémového zdroja.',
  'set.ftype.desc.single_line_text': 'Krátka textová hodnota.',
  'set.ftype.desc.multi_line_text': 'Dlhšia textová hodnota.',
  'set.ftype.desc.checkbox': 'Hodnota pravda alebo nepravda.',
  'set.ftype.desc.dropdown': 'Vyberte jednu normalizovanú možnosť.',
  'set.ftype.desc.dependent': 'Možnosti závisia od nadradeného poľa.',
  'set.ftype.desc.date': 'Hodnota kalendárneho dátumu.',
  'set.ftype.desc.number': 'Celočíselná hodnota.',
  'set.ftype.desc.decimal': 'Hodnota desatinného čísla.',
  'set.src.STATIC': 'Statické možnosti',
  'set.src.AGENTS': 'Agenti',
  'set.src.USERS': 'Používatelia / zákazníci',
  'set.src.GROUPS': 'Skupiny',
  'set.src.ROLE': 'Roly',
  'set.src.COUNTRIES': 'Krajiny',
  'set.src.CUSTOM': 'Vlastný rozbaľovací zoznam',
  'set.settings': 'Nastavenia',
  'set.ticketFields': 'Polia tiketu',
  'set.ticketForms': 'Formuláre tiketov',
  'set.requestFailed': 'Požiadavka zlyhala. Skúste to znova.',
  'set.refresh': 'Obnoviť',
  'set.saving': 'Ukladá sa…',
  'set.saveChanges': 'Uložiť zmeny',
  'set.default': 'Predvolené',
  'set.published': 'Publikované',
  'set.draft': 'Koncept',
  'set.publish': 'Publikovať',
  'set.unpublish': 'Zrušiť publikovanie',
  'set.deleteForm': 'Odstrániť formulár',
  'set.description': 'Popis',
  'set.relationshipSource': 'Zdroj vzťahu',
  'set.dependsOn': 'Závisí od {field}',
  'set.deleteFormTitle': 'Odstrániť „{name}“?',
  'set.deleteFormDescription': 'Tento formulár tiketu a jeho konfigurácia budú trvalo odstránené.',
  'set.formIdRequired': 'Vyžaduje sa ID formulára.',
  'set.formNotFound': 'Formulár tiketu nenájdený.',
  'set.tf.removeOption': 'Odstrániť {label}',
  'set.tf.noOptions': 'Zatiaľ nie sú definované žiadne možnosti.',
  'set.tf.addOptionPlaceholder': 'Pridať možnosť...',
  'set.tf.add': 'Pridať',
  'set.tf.dependsOnField': 'Závisí od poľa',
  'set.tf.selectParent': '— Vyberte nadradené pole —',
  'set.tf.parentHelp': 'Nadradené rozbaľovacie pole, ktorého vybraná hodnota určuje dostupné možnosti tohto poľa.',
  'set.tf.optionMappings': 'Mapovanie možností',
  'set.tf.savingParen': '(ukladá sa...)',
  'set.tf.mappingsError': 'Mapovania sa nepodarilo načítať',
  'set.tf.archivedParen': ' (archivované)',
  'set.tf.mappedCount': 'Namapované: {count}',
  'set.tf.saveFirst': 'Najprv uložte pole, aby ste mohli nastaviť mapovanie možností.',
  'set.tf.newField': 'Nové: {type}',
  'set.tf.pageDescription': 'Spravujte importované definície polí, viditeľnosť, pravidlá povinnosti a poradie používané vo formulároch tiketov.',
  'set.tf.addField': 'Pridať pole',
  'set.tf.addFieldHelp': 'Presuňte typ do zoznamu polí alebo použite Pridať.',
  'set.tf.addType': 'Pridať: {type}',
  'set.tf.registry': 'Register polí',
  'set.tf.savingOrder': 'Ukladá sa poradie…',
  'set.tf.searchAria': 'Hľadať polia tiketu',
  'set.tf.searchPlaceholder': 'Hľadať podľa názvu alebo kľúča...',
  'set.tf.filterAria': 'Filtrovať podľa typu poľa',
  'set.tf.allTypes': 'Všetky typy polí',
  'set.tf.emptyFirstTitle': 'Pridajte svoje prvé pole tiketu',
  'set.tf.emptyFirstDesc': 'Presuňte typ poľa z palety alebo ho vytvorte pomocou Pridať.',
  'set.tf.emptyFilterTitle': 'Týmto filtrom nezodpovedajú žiadne polia',
  'set.tf.emptyFilterDesc': 'Skúste iný hľadaný výraz alebo rozšírte filter typu poľa.',
  'set.tf.archived': 'Archivované',
  'set.tf.dependent': 'Závislé',
  'set.tf.customerVisible': 'Viditeľné pre zákazníka',
  'set.tf.internal': 'Interné',
  'set.tf.configuration': 'Konfigurácia poľa',
  'set.tf.selectTitle': 'Vyberte pole na konfiguráciu',
  'set.tf.selectDesc': 'Vyberte pole z registra a upravte jeho označenia, pravidlá a viditeľnosť.',
  'set.tf.externalId': 'Externé ID: {value}',
  'set.tf.sourceRenderer': 'Zdroj: {source} · Vykresľovač: {renderer}',
  'set.tf.optionSource': 'Zdroj možností: {value}',
  'set.tf.dependsOnKey': 'Závisí od: {value}',
  'set.tf.internalLabel': 'Interné označenie',
  'set.tf.customerLabel': 'Označenie pre zákazníka',
  'set.tf.relationshipHelp': 'Určuje, odkiaľ sa za behu načítavajú hodnoty vyhľadávania.',
  'set.tf.validationVisibility': 'Validácia a viditeľnosť',
  'set.tf.requiredAgents': 'Povinné pre agentov',
  'set.tf.requiredCustomers': 'Povinné pre zákazníkov',
  'set.tf.requiredClosure': 'Povinné pri zatvorení',
  'set.tf.displayedCustomers': 'Zobrazené zákazníkom',
  'set.tf.customersEdit': 'Zákazníci môžu upravovať',
  'set.tf.customersFilter': 'Zákazníci môžu filtrovať',
  'set.tf.active': 'Aktívne',
  'set.tf.dropdownOptions': 'Možnosti rozbaľovacieho zoznamu ({count})',
  'set.tf.archiveTitle': 'Archivovať „{name}“?',
  'set.tf.archiveDesc': 'Pole sa stane neaktívnym a nebude dostupné pre nové tikety. Existujúce údaje tiketov sa zachovajú.',
  'set.tf.archiveField': 'Archivovať pole',
  'set.tf.alreadyArchived': 'Už archivované',
  'set.tf.archivedNote': 'Archivované polia zostávajú dostupné pre historické hodnoty.',
  'set.tfm.systemUser': 'Systém',
  'set.tfm.untitled': 'Formulár bez názvu',
  'set.tfm.pageDescription': 'Vytvárajte opakovane použiteľné formuláre a vyberajte, ktoré importované polia môžu používať agenti a zákazníci.',
  'set.tfm.newForm': 'Nový formulár',
  'set.tfm.creating': 'Vytvára sa…',
  'set.tfm.allForms': 'Všetky formuláre',
  'set.tfm.configuredOne': '{count} nakonfigurovaný formulár',
  'set.tfm.configuredMany': 'Nakonfigurované formuláre: {count}',
  'set.tfm.filter': 'Filter',
  'set.tfm.searchAria': 'Hľadať formuláre tiketov',
  'set.tfm.searchPlaceholder': 'Hľadať formuláre…',
  'set.tfm.status': 'Stav',
  'set.tfm.allStatuses': 'Všetky stavy',
  'set.tfm.emptyFilterTitle': 'Týmto filtrom nezodpovedajú žiadne formuláre',
  'set.tfm.emptyFilterDesc': 'Skúste iný hľadaný výraz alebo rozšírte filter stavu.',
  'set.tfm.emptyFirstTitle': 'Vytvorte svoj prvý formulár tiketu',
  'set.tfm.emptyFirstDesc': 'Vytvorte formulár a začnite konfigurovať importované polia.',
  'set.tfm.createFirst': 'Vytvorte svoj prvý formulár',
  'set.tfm.colName': 'Meno',
  'set.tfm.colCreatedAt': 'Vytvorené',
  'set.tfm.colUpdatedBy': 'Naposledy aktualizoval(a)',
  'set.tfm.colUpdatedAt': 'Naposledy aktualizované',
  'set.tfm.colPortals': 'Priradené portály',
  'set.tfm.colActions': 'Akcie',
  'set.tfm.notConfigured': 'Nenakonfigurované',
  'set.tfm.actionsFor': 'Akcie pre {name}',
  'set.tfm.editForm': 'Upraviť formulár',
  'set.tb.section.default.title': 'Predvolené polia',
  'set.tb.section.default.desc': 'Základné polia pracovného postupu podpory importované zo zdrojového systému.',
  'set.tb.section.custom.title': 'Vlastné polia',
  'set.tb.section.custom.desc': 'Ďalšie polia nakonfigurované pre váš proces podpory.',
  'set.tb.section.nested.title': 'Vnorené polia',
  'set.tb.section.nested.desc': 'Závislé polia, ktorých možnosti sa riadia nadradeným poľom.',
  'set.tb.discardTitle': 'Zahodiť neuložené zmeny?',
  'set.tb.discardDesc': 'Vaše úpravy tohto formulára tiketu neboli uložené.',
  'set.tb.leave': 'Odísť bez uloženia',
  'set.tb.nameRequired': 'Názov formulára je povinný.',
  'set.tb.saved': 'Formulár bol uložený.',
  'set.tb.nowPublished': 'Formulár bol publikovaný.',
  'set.tb.nowUnpublished': 'Publikovanie formulára bolo zrušené.',
  'set.tb.admin': 'Administrácia',
  'set.tb.builder': 'Návrhár',
  'set.tb.titleAria': 'Názov formulára',
  'set.tb.defaultLocked': 'Predvolené / zamknuté',
  'set.tb.previewPortal': 'Náhľad na portáli',
  'set.tb.configureTitle': 'Nakonfigurujte polia zahrnuté v tomto formulári.',
  'set.tb.configureDesc': 'Zmeny sa uložia do databázy centra podpory po výbere Uložiť zmeny. Povinné polia zostávajú zapnuté.',
  'set.tb.formDetails': 'Podrobnosti formulára',
  'set.tb.formDetailsHelp': 'Použite jasný popis, aby administrátori vedeli, kedy tento formulár použiť.',
  'set.tb.descPlaceholder': 'Opíšte, kedy sa má tento formulár použiť…',
  'set.tb.importedFields': 'Importované polia',
  'set.tb.importedHelp': 'Presúvaním zmeňte poradie polí. Prepínačom zahrniete alebo vylúčite pole z tohto formulára.',
  'set.tb.noneInSection': 'V tejto sekcii nie sú žiadne importované polia.',
  'set.tb.dragReorder': 'Presunutím zmeníte poradie',
  'set.tb.required': 'Povinné',
  'set.tb.nested': 'Vnorené',
  'set.tb.enableField': 'Zapnúť {label}',
  'set.tb.enabled': 'Zapnuté',
  'set.tb.disabled': 'Vypnuté',
  'set.tb.emptyTitle': 'Zatiaľ nie sú žiadne polia na konfiguráciu',
  'set.tb.emptyDesc': 'Importujte polia tiketu a začnite vytvárať tento formulár.',
  'set.tb.deleting': 'Odstraňuje sa…',
  'set.tp.loadError': 'Náhľad formulára sa nepodarilo načítať.',
  'set.tp.preview': 'Náhľad',
  'set.tp.customerPreview': 'Náhľad pre zákazníka',
  'set.tp.backToBuilder': 'Späť na návrhára',
  'set.tp.modeTitle': 'Režim náhľadu',
  'set.tp.modeDesc': 'Toto je náhľad bez odosielania. Všetky zapnuté polia sa zobrazujú v uloženom poradí formulára.',
  'set.tp.emptyTitle': 'Zatiaľ nie sú zapnuté žiadne polia',
  'set.tp.emptyDesc': 'Zapnite polia v návrhárovi formulára, aby sa zobrazili v tomto náhľade.',

  'por.error.generic': 'Požiadavku sa nepodarilo dokončiť.',
  'por.error.requestNotFound': 'Požiadavka nenájdená.',
  'por.error.formUnavailable': 'Formulár požiadavky nie je k dispozícii.',
  'por.error.articleNotFound': 'Článok nenájdený.',
  'por.error.selectRating': 'Vyberte hodnotenie od 1 do 5.',
  'por.tab.all': 'Všetky',
  'por.list.title': 'Moje požiadavky na podporu',
  'por.list.description': 'Sledujte svoje požiadavky a odpovedajte tímu podpory.',
  'por.list.newRequest': 'Nová požiadavka',
  'por.list.knowledgeBase': 'Znalostná databáza',
  'por.list.filterByStatus': 'Filtrovať požiadavky podľa stavu',
  'por.list.searchPlaceholder': 'Hľadať podľa predmetu…',
  'por.list.count': 'Požiadavky: {count}',
  'por.list.countOne': '{count} požiadavka',
  'por.list.emptyFilteredTitle': 'Tomuto zobrazeniu nezodpovedajú žiadne požiadavky',
  'por.list.emptyTitle': 'Zatiaľ žiadne požiadavky',
  'por.list.emptyFilteredDescription': 'Skúste kartu Všetky alebo iný hľadaný výraz.',
  'por.list.emptyDescription': 'Odošlite požiadavku a tím podpory sa jej ujme.',
  'por.list.submitFirst': 'Odošlite svoju prvú požiadavku',
  'por.col.request': 'Požiadavka',
  'por.col.subject': 'Predmet',
  'por.col.status': 'Stav',
  'por.col.priority': 'Priorita',
  'por.col.created': 'Vytvorené',
  'por.detail.myRequests': 'Moje požiadavky',
  'por.detail.reopen': 'Znovu otvoriť túto požiadavku',
  'por.detail.attachments': 'Prílohy',
  'por.detail.download': 'Stiahnuť',
  'por.detail.conversation': 'Konverzácia',
  'por.detail.noReplies': 'Zatiaľ žiadne odpovede',
  'por.detail.noRepliesHint': 'Pridajte nižšie odpoveď a tím podpory sa jej ujme.',
  'por.detail.reply': 'Odpoveď',
  'por.detail.replyPlaceholder': 'Napíšte odpoveď',
  'por.detail.sending': 'Odosiela sa…',
  'por.detail.sendReply': 'Odoslať odpoveď',
  'por.file.sizeKb': '{size} KB',
  'por.file.remove': 'Odstrániť {name}',
  'por.submit.newRequest': 'Nová požiadavka',
  'por.submit.defaultTitle': 'Odoslať požiadavku na podporu',
  'por.submit.intro': 'Vyplňte polia nižšie a odošlite požiadavku.',
  'por.submit.subjectRequired': 'Predmet je povinný',
  'por.submit.descriptionRequired': 'Popis je povinný',
  'por.submit.attachments': 'Prílohy',
  'por.submit.submitting': 'Odosiela sa…',
  'por.submit.submit': 'Odoslať požiadavku',
  'por.kb.portal': 'Portál',
  'por.kb.title': 'Znalostná databáza',
  'por.kb.description': 'Nájdite odpovede skôr, než odošlete požiadavku.',
  'por.kb.crumbRoot': 'ZD',
  'por.kb.searchResults': 'Výsledky vyhľadávania',
  'por.kb.searchPlaceholder': 'Hľadať články',
  'por.kb.emptyTitle': 'Zatiaľ nie sú publikované žiadne články',
  'por.kb.emptyDescription': 'Odošlite požiadavku a tím podpory vám pomôže priamo.',
  'por.kb.noFolders': 'Žiadne priečinky',
  'por.kb.articles': 'Články: {count}',
  'por.kb.articlesOne': '{count} článok',
  'por.kb.noMatch': 'Výrazu „{query}“ nezodpovedajú žiadne články',
  'por.kb.folderEmpty': 'V tomto priečinku zatiaľ nie sú žiadne články',
  'por.kb.noMatchHint': 'Skúste kratší hľadaný výraz alebo namiesto toho odošlite požiadavku.',
  'por.kb.folderEmptyHint': 'Prehľadajte iný priečinok alebo namiesto toho odošlite požiadavku.',
  'por.kb.submitRequest': 'Odoslať požiadavku',
  'por.kb.views': '{count} zobrazení',
  'por.kb.thanks': 'Ďakujeme za vašu spätnú väzbu!',
  'por.kb.helpful': 'Bolo to užitočné?',
  'por.kb.yes': 'Áno',
  'por.kb.no': 'Nie',
  'por.csat.thanksTitle': 'Ďakujeme za vašu spätnú väzbu',
  'por.csat.thanksBody': 'Vaša odpoveď bola zaznamenaná.',
  'por.csat.title': 'Ako sa nám darilo?',
  'por.csat.request': 'Požiadavka č. {number}: {subject}',
  'por.csat.rating': 'Hodnotenie',
  'por.csat.stars': 'Hviezdičky: {count}',
  'por.csat.comment': 'Komentár',
  'por.csat.submit': 'Odoslať spätnú väzbu',
  'agents.tempPassword.title': 'Dočasné heslo',
  'agents.tempPassword.help': 'Nastavte tomuto agentovi dočasné heslo. Pri ďalšom prihlásení bude vyzvaný na zadanie nového hesla. Aspoň 12 znakov.',
  'agents.tempPassword.button': 'Nastaviť dočasné heslo',
  'agents.tempPassword.saving': 'Nastavuje sa…',
  'agents.tempPassword.error': 'Dočasné heslo sa nepodarilo nastaviť.',
  'ui.showPassword': 'Zobraziť heslo',
  'ui.hidePassword': 'Skryť heslo',
  'dashboard.awaitingResolutionConfirmation': 'Čaká na potvrdenie vyriešenia',
  'dashboard.awaitingUserReply': 'Čaká na odpoveď používateľa',
  'dashboard.changeRequests': 'Požiadavky na zmenu',
  'agents.tempPassword.successEmailed': 'Dočasné heslo bolo nastavené a odoslané agentovi e-mailom.',
  'agents.tempPassword.successNotEmailed': 'Dočasné heslo bolo nastavené, ale e-mail sa nepodarilo odoslať. Oznámte heslo agentovi zabezpečeným kanálom.',
} as const;

export default sk;
